import './common/globalVar'; //global variables
import SetProfSizes from './common/SetProfSizes';
import scrollInstreamRecircEvents from './common/scrollEvents';
import medianet from './third-parties/medianet';
import MEADS from './third-parties/meads';
import webmd from './common/webmd';
import { SetSubDOMenv, DetectUA, DetectSubD_D, TestAdUnitL1L2 } from './common/setAdTarget';
import { debug } from './common/debug-log';
import addAdElements from './utils/addAdElements';
import staticTargetKeys from './common/staticTargetKeys';
import dynamicTargetkeys from './common/dynamicTargetKeys';
import formulary from './common/formulary-callback';
import { setPIMC, updatePIMC } from './common/pimc';
import { manLayer } from './common/manlayer';
import postRecricWidgetSetUp from './common/post-recirc-widget';
import getPPID from './common/publisher-provider-ID';
import { addRepConnect, displayRepConnect } from './common/repConnect';

window.checkHTML5Creative = true;
//console.log(scrollInstreamRecircEvents);
document.dispatchEvent(new CustomEvent('LibReady', { detail: 'ads' }));

document.addEventListener('userIDComplete', function(data) {
  debug.log("[profads] userIDComplete event Called");
  window.readyPulsePoint = true;
  profads.ads2.init();
});

/* End Shared consumer framework */

/* Start of Prof Ads Framework */

profads.ads2 = {
  profAdsSettings: {
    proGate: true,
    llGate: true,
    AdPrediction: true
  },
  pageAdVars: {},
  dmp: null, //lotame audience values
  lgd: null, // lotame gd value
  insertCount: 0,
  thirdPartyModules: [ // add or remove a 3rd party module to be loaded
    medianet,
    MEADS
  ],
  enableHeaderBidding: true,
  GDPR_optin_check: () => {
    let otStub = document.getElementById('ot-stub');
    let otCcpa = document.getElementById('ot-ccpa');
    return (otStub == null || document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0004%3A1/) != null || (otCcpa != null && document.cookie.match(/OptanonConsent[^;]+&groups/) == null))
  },
  enableHeaderBidding: true,
  /**
     * Function to call once to initialize the ads framework.
     * Can be done at the top or bottom of the page.
     */
  init: function() {
    if (!window.inItOnce) {
      window.inItOnce = true;
      debug.log("[profads] Inside init function");
      const self = this;
      self.defer = new jQuery.Deferred();
      this.addToProfNameSpace.call(this);
      this.readyFunctions = [];
      this.staticTargetKeys = staticTargetKeys;
      this.dynamicTargetkeys = dynamicTargetkeys;
      this.addRepConnect = addRepConnect;
      this.displayRepConnect = displayRepConnect;
      this.initializeWebmdAds = this.initializeWebmdAds.bind(this);
      this.addEventListeners.call(this);
      // load third parties
      if (PageMetadata.reqHeaders.domainCategory === "cme" || window.location.hostname.includes('.org')) {
        self.thirdPartyModules.forEach((mod, index) => {
          if (mod.name && mod.name === 'medianet') {
            self.thirdPartyModules.splice(index, 1);
          }
        });
      }
      self.load3rdPartyModules.call(self);
      // below function interfeering with new modulary footer updates
      webmd.ads2.addSlotRenderEndedCallback('ads-af-pos-1145', profads.ads2.logictoDisplayHTML5);
      // storeDID check only needed for
      if (!self.storeDID) self.storeDID = () => {};

      // set empty object for ignore by ids
      window.ads2_ignoreIds = {};

      // Do a check to make sure nobody tries to run init twice,
      if (self.init.flag) {
        debug.warn("[profads] Init was already called");
        return;
      }
      self.init.flag = true;

      if (PageMetadata.reqHeaders.device == "PC" && profads.ads2.getBrkPnt() == "320-767") {
        PageMetadata.reqHeaders.device = "MOBILE";
        $(document).ready(function() {
          $(window).off('scroll', lazyLoadBlb.lazyLoadBlbscrollHandler);
        })
      }
      if (window._isAnArticle && window.s_responsive_design && window._isRecap == false && window._isODP == false && window._isFFQ == false) {
        if (mobOptCheck == true) window.textDriverOptimized = mobOptCheck;
        window.textDriverOptimized = true;
      }
      GenPVID();
      PageMetadata.reqHeaders.enableDomain = typeof PageMetadata.reqHeaders.enableDomain === 'string' ? PageMetadata.reqHeaders.enableDomain.replace(/qa03/g, "qa02") : "";
      // store the object references containing {priority, asid, size} during initialization of profads
      // note: this does a copy by reference not a copy by value
      self.SetProfSizes = SetProfSizes;
      self.SetProfSizes();
      self.ProfAdsIgnore();
      if (!self.storeDID) self.storeDID = () => {}

      webmd.ads2.googleDefer(function() {
        profads.ads2.lineItemId();
        webmd.ads2.setPageTarget('saf', $.cookie('ads_saf') ||  0);
        // insert 105 and 107 pos container,except mobile device
        if (PageMetadata.reqHeaders.device !== 'MOBILE'
                && PageMetadata.webSegVars.spon !== 'myinvitation'
                && PageMetadata.webSegVars.pc !== 'slideshow'
        ) {
          [ '105', '107' ].forEach(pos => {
            let container = self.utils.createElement({
              name: 'div',
              id: `ads-pos-${pos}`,
              className: `${pos}-layer`
            });

            document.body.appendChild(container);
            webmd.ads2.defineAd({
              id: `ads-pos-${pos}`,
              pos: `${pos}`
            });
          })
        }
      });

      self.readyFunctions.push(() => {
        if (isEmed || isDD) $("#ads-pos-101").attr('style', 'width: 100% !important');
        if ($("#ads-pos-904").length > 0 && (_isAnArticle || isEmed || isDD || _isRecap)) {
          $("#ads-pos-904,#ads-pos-906,#ads-pos-907").width('0%');
          $("#ads-pos-904").before('<div id="top-pick">TOP PICKS FOR YOU</div>');
        }
        if ($('#ads-pos-622').length > 0) $('#ads-pos-622').css('background', 'none');
        if ($('#ads-pos-722').length > 0) $('#ads-pos-722').css('background', 'none');
      });
    }
    if (typeof window.libLoadStatus == 'undefined' || window.libLoadStatus.complete) {
      let scope = profads.ads2;
      function startFramework() {
        // Init from shared WebMD framework to load the google code and set up
        webmd.ads2.init().slotRenderEnded();
        if (scope.KillSwitch()) scope.MakeAdCall();
      }
      if (PageMetadata.reqHeaders.domainCategory != 'cme' && PageMetadata.reqHeaders.device == 'PC' && PageMetadata.webSegVars.pc.indexOf('slideshow') !== -1) {
        $(document).ready(() => { startFramework() });
      } else {
        startFramework()
      }
    }
  },
  addToProfNameSpace() {
    this.postRecricWidgetSetUp = postRecricWidgetSetUp;
    // add functions that became modules or in modules to profads.ads2 namespace
    this.SetSubDOMenv = SetSubDOMenv;
    this.DetectUA = DetectUA;
    this.DetectSubD_D = DetectSubD_D;
    this.TestAdUnitL1L2 = TestAdUnitL1L2;
    this.setPIMC = setPIMC;
    this.updatePIMC = updatePIMC;
  },
  addEventListeners: function() {
    const self = this;
    var count = [];
    window.addEventListener('message', this.postMessageHandler.bind(this));

    // listen to the 'collapse' event from collapse-ad.js
    window.addEventListener('collapse', function(e) {
      const adPosDiv = document.getElementById(e.detail.iframe).parentNode.parentNode;
      debug.log("[profads] Collapse event called", adPosDiv);
      if (adPosDiv.id.indexOf('145') !== -1) {
        if (adPosDiv.style.display === 'none' || $(adPosDiv).hasClass('blank-ad')) {
          self.closeStickyAd = true;
          $(window).trigger('sticky:close')
        }
      }
      if (adPosDiv.id.indexOf('1145') !== -1) {
        const adFooterWrapper = adPosDiv.parentNode.parentNode;
        if (adFooterWrapper && adFooterWrapper.classList.contains('adhesive-footer-wrapper')) {
          adFooterWrapper.style.display = '';
        }
      }
      if (adPosDiv.id.indexOf('622') !== -1) {
        profads.ads2.toggleCME622('blank');
      }
      if (adPosDiv.id.indexOf('909') !== -1 || adPosDiv.id.indexOf('910') !== -1) {
        if (adPosDiv.style.display === 'none' || $(adPosDiv).hasClass('blank-ad') || $(adPosDiv).hasClass('adlabelblank')) {
          if (_isRecap) $("#column-right").outerHeight('1865');
        }
      }
      if (adPosDiv.id.indexOf('909') !== -1) {count.push('0')};
      if (adPosDiv.id.indexOf('910') !== -1) {count.push('0')};
      if (adPosDiv.id.indexOf('122') !== -1) {count.push('0')};
      if (count.length > 1) {
        if (_isRecap) $("#column-right").outerHeight('1555');
      }
    }, false);

    window.addEventListener('display_sticky', (e) => {$(window).trigger('sticky:display')});

    //addEventListener textAd
    window.addEventListener('textAdRender', (e) => {
      debug.log("[profads] textAdRender event called", e);
      const adTextAdDiv = document.getElementById(e.detail.iframe).parentNode.parentNode;
      $(adTextAdDiv).addClass('textAdClass');
    }, false);

    window.addEventListener('displayAggressiveDriver', self.aggressiveDriver.bind(this));

    window.addEventListener('profadsready', (e) => {
      profads.ads2.readyFunctions.forEach(f => {
        if (typeof f == 'function') f();
      });
    });

    window.addEventListener('insertAdhesiveVideo', self.insertAdhesiveVideo);

    window.addEventListener('addCompReportDriver', self.addCompReportDriver);
  },
  initializeWebmdAds: function() {
    webmd.ads2.init();
    webmd.ads2.slotRenderEnded();
    window.$googleloaded = true;
    if (this.KillSwitch()) this.MakeAdCall();
  },
  load3rdPartyModules: function() {
    profads.ads2.thirdPartyModules.forEach(m => {
      debug.log("load3rdPartyModules", m);
      let mod = m.init.call(m);
      // test if module returns a promise, assign to profads, currently only used for lotame
      if (typeof mod === 'object' && mod.hasOwnProperty('promise'))   profads[m.name] = mod;
      if (m.callBack) webmd.tpsvc.cmds.push(m.callBack.bind(m));
    });
  },
  utils: {
    addClassName: 'AdUnit',
    idPrefix: 'content_',
    getHash: function() {
      return (location.hash === '') ? false : location.hash.substr(location.hash.indexOf('#') + 1);
    },
    checkQueryString: function(url, pos, srcMarker = 'layer', site = 'medscape.com') {
      const splitFunc = (_url) => {
        let arr1 = _url.split('%3F');
        let srcString = `src=${srcMarker}_${pos}_${site}`;
        if (_url.length > 1 && arr1[1] != undefined && arr1[1] != '' && (arr1[1].indexOf("%3D") != -1)) {
          url = url + '&' + srcString;
        } else if (_url.length > 1) {
          url = url + '?' + srcString;
        }
      }

      if (url.indexOf('adurl=') != -1) {
        let url1 = url.split('adurl=')[1];
        if (url1 !== '') splitFunc(url.split('adurl=')[1]);
      } else if (url.indexOf('adurl=') == -1) {
        if (url !== '') splitFunc(url);
      }

      return url;

    },
    getTargetContainer: function() {
      const hash = this.getHash();
      let selector = '';
      if (hash) {
        selector = `#${this.idPrefix}${hash.substr(hash.indexOf('#') + 1)}`;
      } else {
        selector = $(`[id^="${this.idPrefix}"]`)[0];
      }

      profads.ads2.currentAdTarget = $(selector);
      return profads.ads2.currentAdTarget;
    },
    getVisibleAd: function() {
      return this.getTargetContainer().find(`.${this.addClassName}`);
    },
    createElement: function(nodeConfig) {
      function nodeIterator(obj) {
        const node = document.createElement(obj.name);
        if (obj.id) node.id = obj.id;
        if (obj.className) node.className = obj.className;
        if (obj.text) {
          if (obj.renderHTML) {
            // if obj.text is a type of element node, append as child to node
            if (typeof obj.text === 'object' && obj.nodeType !== 'undefined') node.appendChild(obj.text);
            else node.innerHTML = obj.text;
          } else node.textContent = obj.text;
        }
        if (obj.type) node.type = obj.type;
        if (obj.attributes) {
          // expects and array of objects
          obj.attributes.forEach((attr) => {
            let key = typeof attr === 'object' ? Object.keys(attr)[0] : attr;
            // test for attributes without a value, like boolean which default to true
            let val = attr[key] || '';
            node.setAttribute(key, val);
          });
        }
        return node;
      }

      let newNode = nodeIterator(nodeConfig);
      // TODO add abilitiy to loop through nested child elements in AppHelpers.createElement
      function childrenNodeLoop(obj) {
        obj.forEach((child) => {
          // recursive loop for nested children
          if (child.children) {
            let parent = nodeIterator(child);
            child.children.forEach((sub) => {
              if (sub.children) {
                let sub_parent = nodeIterator(sub);
                sub.children.forEach(n_sub => { sub_parent.appendChild(nodeIterator(n_sub)) });
                parent.appendChild(sub_parent);
              } else {
                parent.appendChild(nodeIterator(sub));
              }
              newNode.appendChild(parent);
            });
          } else {
            newNode.appendChild(nodeIterator(child));
          }
        });
      }

      if (nodeConfig.children) childrenNodeLoop(nodeConfig.children);
      if (nodeConfig.wrap) newNode = wrap(newNode);
      // TODO: eventHandler needs refinement to capture Bubbling, if (nodeConfig.eventHandler)...
      // https://dev.to/akhil_001/adding-event-listeners-to-the-future-dom-elements-using-event-bubbling-3cp1

      // wrap an single element, for nodes without multiple child elements
      function wrap(node) {
        if (nodeConfig.wrapWith) {
          let wrapper = nodeIterator(nodeConfig.wrapWith);
          return wrapper.appendChild(node);
        }
        return node;
      }

      // create child nodes from array in the config
      return newNode;
    },
    createEvent: function(eventName, config) {
      return new CustomEvent(eventName, {
        detail: config
      });
    },
    appendExternalNode: function(content, container) {
      container = typeof container !== undefined ? container : document.body;
      // if dom hasn't finished rendering, container will still be undefined => wrap in event
      if (container === undefined) {
        document.addEventListener('DOMContentLoaded', () => {
          document.body.appendChild(content);
        });
      } else {
        container.appendChild(content);
      }
      return container;
    },
    closeAppendedNode: function(nodeId) {
      $(`#${nodeId}`).remove();
    },
    isEmpty: function(el) {
      return !$.trim(el.html());
    },
    getScreenOrientation: function() {
      return (window.outerWidth > window.outerHeight) ? 'landscape' : 'portrait';
    },
    loadScript: function(config) { // config object properties: url, onLoadHandler, cors
      let script = document.createElement('script');
      let parent = config.placement ? config.placement : document.head;
      script.src = config.src;
      if (config.async) script.setAttribute('async', '');
      if (config.cors) script.setAttribute('crossorigin', '');
      parent.insertBefore(script, null);
      if (config.handler) script.onload = config.handler;
      if (config.onerror) script.onerror = config.onerror;
    },
    isSlideShow: function() {
      const path = location.pathname;
      return (path.indexOf('/slideshow/') !== -1 && path.indexOf('/features/') === -1);
    },
    hasEcdQuery: function() {
      return window.location.search.indexOf('ecd=conmkt') !== -1;
    },
    isParent: function(posArray, id) {
      // TODO check if this function is still being used
      // test that posArray only contains numbers !isNaN()
      const validPos = posArray.every(val => {
        return !isNaN(parseInt(val));
      });
      if (!validPos) throw Error('you must provide an array with numbers as the pos value.');
      // test whether the id is contained in posArray, first convert id into a number
      // pos is made from the commonly used id format, ex: 'ads-pos-1145'
      let pos = parseInt(id.split('-').pop());
      // temp hard coded check for old sticky footer id, remove old sticky footer
      return posArray.indexOf(pos) !== -1;
    },
    toggleAdLabel: function(label, ad, adClass) {
      if (label == "ifi") {
        ad.className = `${adClass} adlabelifi`;
      } else if (label == "ifg" || label == "gov") {
        ad.className = `${adClass} adlabelifg`;
      } else if (label == "blank" || label == "none") {
        ad.className = `${adClass} adlabelblank`;
      }
      return ad.className;
    },
    processingQueue: function() {
      return {
        items: [], // Array is used to implement a Queue
        enqueue(item) {
          // adding item to the queue
          this.items.push(item);
        },
        dequeue() {
          // removing element from the queue
          // returns underflow when called
          // on empty queue
          if (this.isEmpty()) {
            return 'Underflow';
          }
          return this.items.shift();
        },
        front() {
          // returns the Front element of
          // the queue without removing it.
          if (this.isEmpty()) {
            return 'No elements in Queue';
          }
          return this.items[0];
        },
        isEmpty() {
          // return true if the queue is empty.
          return this.items.length == 0;
        },
        process(cb) {
          while (this.items.length > 0) {
            if (cb && typeof cb === 'function') {
              cb(this.front());
            }
            this.dequeue();
          }
        }
      };
    },
    getEnvironment() {
      let env = PageMetadata.reqHeaders.requestEnv;
      return env == "" ? "" : `.${env}`;
    },
    setRequestAnimationFrame() {
      return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                window.oRequestAnimationFrame;
    },
    checkConditionRepeat(condition, time = 2000) {
      let start, myReq;
      const maxTime = time;
      const requestAnimationFrame = profads.ads2.utils.setRequestAnimationFrame();
      // if condition is not a param, return
      if (condition === undefined) throw new Error('a condition must be passed as an argument');

      return new Promise((resolve, reject) => {
        function step(timestamp) {
          let _condition = typeof condition === 'function' ? condition() : condition;
          if (start === undefined) start = timestamp;

          const elapsed = timestamp - start;

          if (_condition) {
            cancelAnimationFrame(myReq);
            resolve(_condition);
          }

          if (elapsed < maxTime) { // Stop the animation after 2 seconds
            myReq = requestAnimationFrame(step);
          } else if (elapsed >= maxTime) {
            reject('max time reached to check condition');
            cancelAnimationFrame(myReq);
          }
        }
        myReq = requestAnimationFrame(step);
      });
    },
    elementInView(ele, percent = 100) {
      if (!ele) {
        debug.error('[profads] ele parameter is missing or not a DOM element in elementInView Callback');
        return;
      }
      const winHeight = window.innerHeight;

      const rect = ele.getBoundingClientRect();
      let amount, condition = (rect.top >= 0 && rect.bottom <= winHeight);

      if (percent < 100) {
        amount = rect.height * parseFloat(`.${percent}`);
        condition = (rect.top >= amount && rect.top < winHeight) || (rect.bottom >= amount && rect.bottom < winHeight);
      }

      return condition;
    },
    breakPoints: [
      { bp1: '(min-width: 320px) and (max-width: 767px)' },
      { bp2: '(min-width:768px) and (max-width: 1023px)' },
      { bp3: '(min-width:1024px) and (max-width: 1399px)' },
      { bp4: '(min-width: 1400px)' }
    ],
    getBrkPnt(getNumber = true) {
      // if getNumber is set to true, return a number object, if not return key (string value)
      const bp = this.breakPoints.filter(query => {
        return window.matchMedia(Object.values(query)[0]).matches;
      })[0];
      let key = Object.keys(bp)[0];
      if (getNumber) {
        return key !== undefined ? parseInt(key.substr(key.length - 1)) : 1;
      } else {
        return key !== undefined ? key : undefined;
      }
    },
    cleanTargetKey(targetKey) {
      let returnKey = 0;
      switch (typeof targetKey) {
      case 'object':
        returnKey = targetKey === null ? '0' : ((Array.isArray(targetKey) && targetKey.length === 0) ? '0' : targetKey);
        break;
      case 'string':
        returnKey = targetKey.length === 0 ? '0' : targetKey;
        break;
      case 'number':
        returnKey = targetKey.toString();
        break;
      default:
        returnKey = targetKey;
      }
      return returnKey;
    },
    getGeoLocation(data = {}, source = "") {
      let geo, ous;
      const geoLocations = [
        "AD", "AL", "AN", "AT", "AX", "AZ", "BA",
        "BE", "BG", "BV", "BY", "CH", "CY", "CZ",
        "DE", "DK", "EE", "ES", "FI", "FO", "FR",
        "GB", "GE", "GG", "GI", "GL", "GR", "HR",
        "HU", "IC", "IE", "IM", "IS", "IT", "JE",
        "LI", "LT", "LU", "LV", "MC", "MD", "ME",
        "MQ", "MT", "NL", "NO", "PL", "PT", "RO",
        "RS", "RU", "SE", "SI", "SJ", "SK", "SM",
        "UA", "VA", "XK"
      ];

      if (profads.ads2.getParam('geo') !== "") {
        geo = profads.ads2.getParam('geo');
        ous = true;
      } else {
        geo = window.DFPTargetKeys.reqHeaders.geoc;
        ous = geoLocations.includes(geo);
      }

      if (data.slotId) {
        const iframe = document.querySelector(`#${data.slotId} iframe`);
        if (iframe) iframe.contentWindow.postMessage(JSON.stringify({ "geo": geo, "ous": ous }), "*");
      }
      return { OUS: ous, geo: geo };
    },
  },
  postOmnitureData: function(data) {
    if (typeof data.textLink !== "undefined") s_md.contextData['wb.lnktxt'] = data.textLink;
    if (typeof data.sact !== "undefined") s_md.contextData['wb.sact'] = data.sact;
    if (typeof data.sprod !== "undefined") s_md.contextData['wb.sprod'] = data.sprod;    
    if (typeof data.qacseg !== "undefined") { 
        wmdSetContext({'wb.qacseg': data.qacseg});
        addLinkTrackVars('wb.qacseg');        
    }

    if (typeof data.extLink !== "undefined") {
      let regEx = /\/+$/;
      let exitLink = regEx.test(data.extLink) === true ? data.extLink.replace(regEx, '') : data.extLink;
      [ 'http://', 'https://', 'www.' ].forEach(x => {
        if (exitLink.indexOf(x) !== -1) exitLink = exitLink.slice(x.length);
      });

      exitLink.indexOf('medscape.com') === -1 ? wmdSetContext('wb.exiturl', 'exit::' + exitLink) : wmdSetContext('wb.cstm', 'landpg::' + exitLink);
    }

    wmdPageLink(data.mmodule + "_" + data.mlink);

    if (typeof data.callBack === 'function') data.callBack(); 

    if (typeof data.textLink !== "undefined") s_md.contextData['wb.lnktxt'] = "";

    if (typeof data.extLink !== "undefined") data.extLink.indexOf('medscape.com') === -1 ? wmdRemContext('wb.exiturl') : wmdRemContext('wb.cstm');

  },
  postCpData: function(cpdata, callback) {
    delete cpdata.callBack;
    // cpdata and cpdata.uid should be defined to make CP Ajax call
    // commenting the wrong if condition -> if (typeof cpdata != 'undefined' && (typeof s_registered_user_id != 'undefined' || (typeof cpdata.uid != 'undefined' && cpdata.uid.trim() != ''))) {
    if (typeof cpdata != 'undefined') {

      if (typeof window.s_registered_user_id != 'undefined' && (typeof cpdata.uid == 'undefined' || cpdata.uid.trim() == '')) {
        cpdata.uid = window.s_registered_user_id;
      }

      if (typeof cpdata.uid != 'undefined' && cpdata.uid.trim() != '') {
        if (typeof cpdata.url == 'undefined') {
          cpdata.url = encodeURIComponent(window.location.href.split("?")[0]);
        }
        cpdata.date = new Date().getTime();
        let cpJSON = JSON.stringify(cpdata);
        const ajaxUrlPath = `//api${this.utils.getEnvironment()}.medscape.com/cp/events.json`;

        $.ajax({
          type: "GET",
          contentType: "application/jsonp",
          url: ajaxUrlPath,
          data: 'event=' + cpJSON,
          dataType: "jsonp",
          timeout: 2000,
          complete(XHR, status) {},
          error(XHR, errTxt) {}
        });
        if (typeof callback != 'undefined' && typeof callback == 'function') {
          callback();
        }
      }
    }
  },
  clearBlankAds: function() {
    for (let i in webmd.ads2.ads) {
      let _ad = document.getElementById(`#${webmd.ads2.ads[i]['id']}`);
      if (!_ad) return;
      if (_ad.classList.contains('blank-ad')) {
        _ad.classList.remove('blank-ad');
        _ad.classList.add('AdUnit');
      }
    }
    return this;
  },
  adTracking: {
    track: function(string, url) {
      wmdPageLink(string);
    },
    extLink: function(string, url) {
      wmdSetContext('wb.exiturl', 'exit::' + url);
      wmdPageLink(string);
      wmdRemContext('wb.exiturl');
    },
    intLink: function(string, url) {
      wmdSetContext('wb.cstm', 'landpg::' + url);
      wmdTrack(string);
      wmdRemContext('wb.cstm');
    },
    isInternalExternal: function(url) {
      const urlArray = url.split('/');
      let destination;
      if (urlArray.indexOf('medscape') !== -1 || urlArray[0].charAt[0] === '/') {
        destination = 'internal';
      } else {
        destination = 'external'
      }
      return destination;
    }
  },
  insertLayerAd(data) {
    const that = profads.ads2;
    let config = data.detail === undefined ? data : data.detail;
    let delay = config.delay || 0;
    new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(config);
        if (!config) reject('event config not defined');
      }, delay);
    }).then(config => {
      // the new name of the cpc layer is NativeConnect, so we want to map the names for future use
      const layerType = [
        { 'LLR': 'LLR' },
        { 'layer-cpc': 'NativeConnect' },
        { 'native-footer': 'NativeFooter' },
        { 'promo-layer': 'PromoLayer' },
        { 'toaster': 'Toaster' },
        { 'ecx-layer': 'ECXLayer' }
      ].filter(l => Object.keys(l)[0] === config.productType)[0];

      const layerName = Object.values(layerType)[0];
      const fileName = `${layerName}.js`.toLowerCase();
      config.layerType = layerName;
      // do not load more than once

      if (typeof that[layerName] === 'function') return;

      that.utils.loadScript({
        src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
        handler() {
          if (typeof that[layerName] !== 'function') return;
          // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
          const NativeAdCLass = that[layerName].name + 'LayerAd';
          //that[layerName] is the class extended from the LayerAd class
          //that[NativeAdCLass] is an instance of that class
          that[NativeAdCLass] = new that[layerName](config);
          that[NativeAdCLass].render();
        },
        errorHandler(err) { debug.error('[profads] Layer ad script failed to load.', err); },
        async: true
      });
    }).catch(err => {debug.error('[profads] insertLayerAd error: ', err); });
  },
  insertImpactPoll(e) {
    const that = this;
    that.utils.loadScript({
        src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/impactpoll.js`,
        handler() {  profads.ads2.initImpactPoll(e); },
        errorHandler() { console.error('Impact poll script failed to load.'); },
        async: true,
        cors: true
    });
    return that;
  },
  insertAdhesiveVideo(e) {
    const that = this;
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/profads-adhesive-video.js`,
      handler() { that.initAdhesiveVideo(e) },
      errorHandler() { debug.error('[profads] Adhesive video script failed to load.'); },
      async: true,
      cors: true
    });
    return that;
  },
  insertParallax(e) {
    const that = this;
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/parallax.js`,
      handler() { that.initParallax(e); },
      errorHandler() { console.error('parallax script failed to load.'); },
      async: true,
      cors: true
    });
    return that;
  },
  addCompReportDriver(e) {
    const that = this;
    if(window.breakpoint == 1){
      window.checkHTML5Creative = false;
    }
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/comp-report-driver.js`,
      handler() { that.loadCompReport(e) },
      errorHandler() { debug.error('[profads] Comp report driver script failed to load.'); },
      async: true,
      cors: true
    });
    return that;
  },
  aggressiveDriver: function(config) {
    let that = this;
    let layerName = "aggressiveDriverExt";
    let fileName = "mdscp-aggressivedriver.js";

    if (typeof that[layerName] === 'function') {
      that[layerName](config);
      return;
    }
    that.utils.loadScript({
      src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
      handler() {
        if (typeof that[layerName] !== 'function') return;
        // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
        that[layerName](config);
      },
      errorHandler(err) { debug.error('[profads] aggressiveDriver ad script failed to load.', err); },
      async: true
    });
  },
  invMobileFooter: function(config) {
    let that = this;
    let layerName = "invMobileFooterExt";
    let fileName = "mdscp-invmobilefooter.js";

    if (typeof that[layerName] === 'function') {
      that[layerName](config);
      return;
    }
    that.utils.loadScript({
      src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
      handler() {
        if (typeof that[layerName] !== 'function') return;
        that[layerName](config);
      },
      errorHandler(err) { debug.error('[profads] invMobileFooter ad script failed to load.', err); },
      async: true
    });
  },
  displayAdhesiveFooter(e) {
    const that = this;
    if (window.breakpoint === 1) {
      window.checkHTML5Creative = false;
      $('.adhesive-footer-wrapper').show();
    }
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/mdscp-adhesive-footer.js`,
      handler() { that.initAdhesiveFooter(e) },
      errorHandler() {  debug.error('[profads] Adhesive footer script failed to load.'); },
      async: true,
      cors: true
    });
    return that;
  },
  ResizeTextAds: function() {
    let that = this;
    let methodName = "resizeTextAdsExt";
    let fileName = "mdscp-resizetextads.js";

    if (typeof that[methodName] === 'function') {
      that[methodName]();
      return;
    }
    that.utils.loadScript({
      src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/${fileName}`,
      handler() {
        if (typeof that[methodName] !== 'function') return;
        // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
        that[methodName]();
      },
      errorHandler(err) { debug.error('[profads] resizeTextAd ad script failed to load.', err); },
      async: true
    });
  },
  // Confluence reference: https://confluence.webmd.net/display/ProfessionalDev/Omniture+IFI+tracking
  trackNative: function(data) {
    wmdSetContext('wb.lnktxt', data.text);
    if (this.adTracking.isInternalExternal(data.href) === 'external') {
      profads.ads2.adTracking.extLink(data.track, data.href);
    } else {
      profads.ads2.adTracking.intLink(data.track, data.href);
    }
  },
  brandAlertLauncherCB: function(eventData) {
    console.log("Starting brandAlertLauncherCB callback");
    if (eventData.type == ! 'brandalert-launcher') {
      return;
    }

    const env = window.PageMetadata.reqHeaders.requestEnv;
    let imgSrvEnv = env === '' ? 'img.medscapestatic.com' : `img.${env}.medscapestatic.com`;
    const payload = eventData.payload;

    const injectedScript = document.createElement("script");

    injectedScript.id = "brandalert_launcher";
    injectedScript.src = `//${imgSrvEnv}/medscape-promo/brandalert_vue/4/dist/launcher/brandalert-launcher-session.js`;
    injectedScript.addEventListener("load", function() {
      window.BrandAlertLauncher.init(payload);
    });
    document.body.appendChild(injectedScript);
    console.log("End of brandAlertLauncherCB callback");
  },
  headlineBrandAlertCB: function(data) {
    var alerturl = data.alertUrl;
    var actid = data.actId || null;
    var parentBody = window.top.document.body;
    var script = document.createElement("script");
    var imgSrv =
            PageMetadata.reqHeaders.requestEnv === ''
              ? 'img.medscapestatic.com'
              : `img.${PageMetadata.reqHeaders.requestEnv}.medscapestatic.com`;

    script.id = "brandalert_launcher";
    script.type = "text/javascript";
    script.setAttribute('data-ba-url', alerturl);

    // legacy brandalert (no actid)
    script.src = `//${imgSrv}/medscape-promo/brandalert/1/brandalert-launcher-session.bundle.js`;

    // j360 supported brandalert (actid)
    if (actid) {
      script.src = `//${imgSrv}/medscape-promo/brandalert_vue/4/dist/launcher/brandalert-launcher-session.js`;
      script.setAttribute('data-ba-actid', actid);
    }

    parentBody.appendChild(script);
  },
  addBrandAlert: function() {
    var isMobile = false;
    if (PageMetadata.reqHeaders.device === "MOBILE") {
      isMobile = true;
    }

    var posIdSlot1 = "622";
    var posIdSlot2 = "722";
    if (isMobile) {
      posIdSlot1 = "1622";
      posIdSlot2 = "1722";
    }
    var slot1Html = '<li id="ads-pos-' + posIdSlot1 + '" class="AdUnit"></li>';
    var slot2Html = '<li id="ads-pos-' + posIdSlot2 + '" class="AdUnit"></li>';

    // news article, not a reference and not a partner article
    if ((/\/viewarticle\//).test(location.pathname) && trackurl.indexOf('reference') === -1 && $(".partner-badge").length === 0 && breakpoint !== 1) {
      var checkRecommendations = $('#rel-recommend');
      if (checkRecommendations.length != 0) {
        var recommendations = $('#rel-recommend li');
        recommendations.eq(0).after(slot1Html);
        webmd.ads2.defineAd({
          id: 'ads-pos-' + posIdSlot1,
          pos: posIdSlot1
        });
        // temporary fix for change html structure in news article ifi
        $('.ifi-container').css({ 'border': 'none', 'padding': 0, 'margin': '0' });
        $('.ifi-title').css('width', '149px');
      }

    }

    // reference homepage
    if ($('#dd-hp').length !== 0) {
      if (isMobile) {
        $('#dd-hp h1').after(slot1Html);
      } else {
        $('#featured li').eq(2).before(slot1Html);
      }
      webmd.ads2.defineAd({
        id: 'ads-pos-' + posIdSlot1,
        pos: posIdSlot1
      });
    }

    // news homepage
    if (typeof isNewsHomepage !== 'undefined' && isNewsHomepage && $('.medscape_today').length === 0 && $('.cardiology').length === 0) {
      $('.latest_news ul.articles li:eq(0)').after(slot1Html);
      $('.latest_news ul.articles li:eq(3)').after(slot2Html);

      webmd.ads2.defineAd({
        id: 'ads-pos-' + posIdSlot1,
        pos: posIdSlot1
      });
      webmd.ads2.defineAd({
        id: 'ads-pos-' + posIdSlot2,
        pos: posIdSlot2
      });
    }

  },
  brandAlertCB: function(eventData) {
    var posVal = eventData.pos;
    $('#ads-pos-' + posVal).addClass('active');
    // reference homepage
    if ($('#dd-hp').length !== 0 && $('#ads-pos-' + posVal).parents('#featured').length > 0) {
      $('#featured li').eq(3).remove();
    }
    // news homepage
    if (typeof isNewsHomepage !== 'undefined' && isNewsHomepage && $('.medscape_today').length === 0 && $('.cardiology').length === 0) {
      if ($('#ads-pos-' + posVal).parents('.latest_news').find('.column2').length > 0) {
        if ($('#ads-pos-' + posVal).parents('.column1, .column2').find('li').length > 4) {
          $('#ads-pos-' + posVal).parents('.column1, .column2').find('li:not(.nativecallouts-item):last').remove();
        }
      }
      else {
        if ($('.latest_news .articles li').length > 8) {
          $('.latest_news .articles li:not(.nativecallouts-item):last').remove();
        }
      }
    }
    if (_isAnArticle) {
      profads.ads2.toggleCME622('template');
    }
  },
  ppuPageCB: function(data) {
    //console.log('ppuPageCB data', data);
    const { slotId, ppuUrl, ppuActId, campaignId } = data;
    const adContainer = document.getElementById(slotId);

    let newIframe = document.createElement('iframe');
    let url = new URL(`${window.location.origin}${ppuUrl}`);

    if (ppuActId) {
      url.searchParams.append("actId", ppuActId);
    }
    if (campaignId) {
      url.searchParams.append("saf", campaignId);
      webmd.ads2.setPageTarget('saf', campaignId);
    }

    adContainer.style.top = "0";
    newIframe.id = 'ppu';
    newIframe.src = url.href;
    newIframe.style.height = '1050px';
    newIframe.setAttribute('allowfullscreen', '');
    adContainer.prepend(newIframe);
  },
  getIframeHeight: function(data) {
    var height = data.height;
    const adDiv = document.getElementById(data.slotId);
    if (PageMetadata.webSegVars.pc == "mymedpg" && (document.getElementById('ads-pos-622') != null)) {
      document.getElementById('ads-pos-622').style.paddingBottom = "0px";
      $('div#ads-pos-622 iframe').height(height);
    }
    if (adDiv && adDiv != null) {
      adDiv.style.paddingBottom = "0px";
      document.querySelector(`#${data.slotId} iframe`).style.height = `${height}px`;
    }
  },
  addHeight: function() {
    $('#ads-pos-520-sfp div iframe').height('auto');
    $(".coe_featured li.ad-item").css('display', 'block');

  },
  addHeightInvitePage: function(data) {
    var setHeight = data.height;
    $('#ads-pos-201').css({ 'padding-top': '10px' });
  },
  addHeightTemplate: function(data) {
    var pos = data.adpos;
    var height = data.height;
    var iHeight = parseInt(data.size);
    var ele = '#ads-pos-' + pos + ' div iframe';
    $(ele).height(height);
    if (pos == 141) {
      let borderStyle = '1px solid #ccc';
      if (document.querySelectorAll('#rel-links-container #ads-pos-141 iframe').length != 0) {
        document.querySelectorAll('#rel-links-container #ads-pos-141 iframe')[0].style.borderRight = borderStyle;
      }
      if (document.querySelectorAll('.AdUnit.adSpcHolder #ads-pos-141 div iframe').length != 0) {
        document.querySelectorAll('.AdUnit.adSpcHolder #ads-pos-141 div iframe')[0].style.borderRight = borderStyle;
      }
    }
  },
  addBackgroundColor: function(data) {
    let containerDivId = data.slotId;
    let containerBgColor = data.bgColor;
    let containerElement = document.getElementById(containerDivId);
    if (containerElement) {
      containerElement.style.backgroundColor = containerBgColor;
    }
  },
  removePinlines: function(data) {
    const posDiv = data.slotId;
    const posEle = document.getElementById(posDiv);
    if (posEle) {
      posEle.style.borderTop = "none";
      posEle.style.borderBottom = "none";
    }
  },
  addTextAdClass: function(data) {
    var pos = data.adpos;
    if (pos) {
      var position = "ads-pos-" + pos;
      $("#" + position).addClass('textAdClass');
    }
    else {
      var id = data.id;
      document.getElementById(id).parentElement.classList.add("textAdClass");
    }
    if (pos == "1145") {
      if ($('#ads-pos-1145').length > 0) {
        $('#ads-pos-1145').attr('style', 'padding:25px 37px 8px 12px;background-position:12px 18px;width:349px');
      }
    }
  },
  addActiveClass: function(data) {
    var pos = data.adpos;
    var position = "ads-pos-" + pos;
    $("#" + position).addClass('active');
    if (pos == '420' || pos == '1420') {
      if ($('.hp_manual2col .section-container ul li:nth-child(4)').length > 0) {
        $('.hp_manual2col .section-container ul li:nth-child(6)').remove();
        $('.hp_manual2col .section-container ul li:nth-child(4)').css('display', 'block');
      }
    }
  },
  changeWidth: function(data) {
    var pos = data.adpos;
    var position = "#ads-pos-" + pos;
    if (pos == '1122') {
      $(position).css('width', '100%');
    }
    if (pos == '1004') {
      $(position).attr('style', 'width:300px;margin:0 auto');
    }
  },
  addIpadStyles: function(data) {
    var pos = data.adpos;
    if ($('.inLine' + pos).length > 0 && (breakpoint != 1)) {

      $('.inLine' + pos).css('width', 'auto');
    } else if ($('#ads-pos-' + pos).length > 0 && (breakpoint != 1)) {
      $('#ads-pos-' + pos).css('width', 'auto');
    }
    if (pos == '420' || pos == '520') {
      if ($(window).width() >= 1024) {
        $('#ads-pos-' + pos).attr('style', 'padding-top:16px !important;padding-bottom:15px !important;width:100%');
      } else if ($(window).width() >= 768 && $(window).width() < 1024) {
        $('#ads-pos-' + pos).attr('style', 'padding-top:16px !important;padding-bottom:15px !important;width:auto');
      }
    } else if (pos == '1420' || pos == '1520') {
      $('#ads-pos-' + pos).attr('style', 'padding-top:15px !important;padding-bottom:16px !important');
    }
  },
  inFocusBadge: function(data) {
    let { bgColor, text } = data.payload["inFocusLabel"];

    let htmlContent = `<div class="infocus-label" style="display: inline-block;
        font-family: proxima_nova_rgregular,sans-serif;
        font-weight: 600;
        font-size: 0.75rem;
        background-color: ${bgColor ? bgColor : "#ECF5F9"};
        padding: 0.5rem 0.75rem;
        border-radius: 0.25rem;
        line-height: 0.75rem;
        letter-spacing: 0.063rem;
        text-transform: uppercase;
        ">${text ? text : "In Focus Series"}</div>`;
    debug.log('[profads] InFocusBadge Event called');

    const ele = document.querySelector('.infocus-label');
    if (!ele) document.querySelector(".heading .breadcrumb").insertAdjacentHTML('afterend', htmlContent);
  },
  addStylesInvite: function(data) {
    var pos = data.adpos;
    $("#ads-pos-" + pos).css({ 'padding-top': '14px', 'padding-bottom': '19px', 'border-top': '6px solid #e0e4e7', 'background': 'none' });
  },
  addCoeStyles: function(data) {
    var pos = data.adpos;
    document.getElementById('ads-pos-' + pos + '-sfp').style.backgroundImage = "none";
    if (pos == '420' || pos == '1420') {
      var ele1 = document.querySelectorAll('.hp_bucket2col .section-container ul li:nth-child(4)')[0];
      var ele2 = document.querySelectorAll('.hp_bucket2col .section-container ul li:nth-child(6)')[0];
      if (document.querySelectorAll('.hp_bucket2col .section-container ul li:nth-child(4)').length > 0) {
        ele2.parentNode.removeChild(ele2);
        ele1.style.display = "block";
      }
    }
  },
  addCoeStylesFooter: function(data) {
    var pos = data.adpos;
    var ele = document.getElementsByClassName('coe-featured')[0];
    if (ele != undefined) {
      ele.classList.add('has-ad');
    }
    if (pos == "420") {
      var sfp420frame = document.querySelector('div#ads-pos-420-sfp iframe');
      if (sfp420frame !== null) {
        sfp420frame.style.width = "100%";
      }

    }
    if (pos == '1420') {
      var sfp1420div = document.getElementById('ads-pos-1420-sfp');
      if (sfp1420div !== null) {
        sfp1420div.style.marginBottom = "20px"
      }
    }
    if (pos == '1424') {
      let ele1424 = document.querySelector('#' + data.slotId);
      if (ele1424 !== null) {
        ele1424.style.width = '100%';
        ele1424.style.marginBottom = '43px';
      }
    }
  },
  toggleCME622: function(data) {
    if (_isAnArticle) {
      var getRelatedUL = document.querySelector("#rel-recommend ul");
      if (getRelatedUL !== null) {
        var cmeData = document.querySelectorAll(".cme-data");
        for (var i = 0; i < cmeData.length;i++) {
          var getParentElement = cmeData[i].parentElement;
          if (data == "template") {
            getRelatedUL.appendChild(getParentElement);
          }
          else {
            getRelatedUL.insertBefore(getParentElement, getRelatedUL.childNodes[1]);
          }
        }
      }
    }
  },
  getIframeParentElement: function(data, source) {
    var adContainer;
    var adSlotId = data.slotId;
    var adPos = data.adpos;
    //Variable to reference  the frame element.
    if (adSlotId != undefined) {
      adContainer = document.getElementById(adSlotId);
    }
    else if (data.adpos != undefined) {
      adContainer = document.getElementById("ads-pos-" + data.pos);
    }
    else {
      var adFrameElement = window.parent.document.getElementById(data.id);
      // recent error 7/27/20  data does not have a slotId, id, or adpos. Possibly due to some templates not having updated script
      if (adContainer == null) return;
      adContainer = window.parent.document.getElementById(adFrameElement.parentNode.parentNode.id);
    }
    if (adContainer !== null) {
      //Regex expression to match the ad classes.
      var resetRegex = /adlabelifi|adlabelifg|adlabelblank/gi;
      //Reset adClass. Remove ad label classes, and trim white space.
      var adClass = adContainer.className.replace(resetRegex, '').trim();
      //Reset class names on the ad container.
      adContainer.className = adClass;
      var adLabelCheck = data.adLabel && data.adLabel.toLowerCase();

      if (adPos == "141") {
        if (!$(adContainer).hasClass('AdUnit')) adClass = "AdUnit";
      }
      this.utils.toggleAdLabel(adLabelCheck, adContainer, adClass);
    }
    return adContainer;
  },
  adTrackingLoaded: false,
  adTrackingQueue: null,
  loadAdTracking: function(data) {
    profads.ads2.adTrackingQueue = profads.ads2.adTrackingQueue || profads.ads2.utils.processingQueue();
    const adData = data;

    // add page data to tracking call data
    adData.pageName = s_md.pageName;
    adData.pageURL = s_md.pageURL;

    // add data to array for processing once script has loaded
    profads.ads2.adTrackingQueue.enqueue(adData);

    if (!profads.ads2.adTrackingLoaded) { // load script once
      profads.ads2.adTrackingLoaded = true;
      profads.ads2.utils.loadScript({
        src: "//img" + profads.ads2.SetSubDOMenv() + ".medscapestatic.com/medscape-promo/poc-ads/adTrackingIframe.bundle.js",
        handler: function() {
          window.pocAdTracking.init();
          profads.ads2.adTrackingQueue.process(window.pocAdTracking.queue);
        },
        async: true
      });
    }

    if (profads.ads2.adTrackingLoaded && window.pocAdTracking) {
      profads.ads2.adTrackingQueue.process(window.pocAdTracking.queue);
    }
  },
  responsivePOCAdCB: function(data) {
    function makeResponsive(element) {
      var parent = element.parentNode;
      if (!parent.classList.contains('AdUnit')) {
        parent.style.width = '100%';
        makeResponsive(parent);
      }
      return false;
    }
    function setIframeParentStyles(iframe) {
      // allow edge-to-edge on outside container on mobile
      iframe.parentNode.parentNode.style.position = 'absolute';
      iframe.parentNode.parentNode.style.left = '0px';
      iframe.parentNode.parentNode.style.right = '0px';
    }
    function setIframeStyles(iframe) {
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      if (PageMetadata.reqHeaders.device == 'MOBILE') {
        // mobile
        if (data.productName === 'brandspot') {
          iframe.style.width = '100%';
        }
        else iframe.style.width = vw < 414 ? vw + 'px' : '414px';
        setIframeParentStyles(iframe);
      } else {
        // desktop
        if (data.productName === 'brandspot') {
          iframe.style.width = '400px';
        }

        iframe.style.display = 'block';
        iframe.style.position = 'relative';
        iframe.style.margin = '0px auto';
      }
    }

    var adIframe = document.querySelector("[id^='" + data.iframeId + "']");
    if (adIframe !== null) {
      setIframeStyles(adIframe);
      makeResponsive(adIframe);
      window.addEventListener('resize', function() {
        setTimeout(function() {
          setIframeStyles(adIframe);
        }, 100);
      });
    }
  },
  postMessageHandler: function(event) {
    const hostSafeList = [ 'medscape', 'googlesyndication', '2mdn' ];
    function isSafe() {
      return hostSafeList.filter((host) => {
        return event.origin.indexOf(host) !== -1;
      }).length > 0;
    }
    function isJsonString(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        //console.warn('not valid JSON', str, e);
        return false;
      }
    }
    function getFunction(arg) {
      return Function('return ' + arg);
    }

    // only allow postMessages from white listed domains with a valid callback function
    if (isSafe()) {
      const data = typeof event.data === 'object' ? event.data : isJsonString(event.data);
      if (data.callback) data.callBack = data.callback;
      if (data.callBack) {
        if (typeof this[data.callBack] === 'function') {
          this[data.callBack](data, event.source);
        } else if (data.callBack.split('.').length > 1) { // check for nested methods with dot syntax
          let method = getFunction(data.callBack);
          if (typeof method === 'function') method()(data, event.source);
        } else {
          debug.warn('[profads] callBack not found', data.callBack);
        }
      }
    }
  },
  // test for isDD and not isEmed
  isDrug: function() {
    return (isDD && !isEmed);
  },
  stickyAd: function(isMobile) {
    this.stickyAdLoaded = false;
    const adID = isMobile ? 'ads-af-pos-1145' : 'ads-af-pos-145';
    const ifiLabelClass = 'adlabelifi';
    const that = this;
    const container = $('#stick-ad-outter-wrapper');
    const innerContainer = $('.innerAdContainer');
    let expandCount = 0;
    innerContainer.css('background', 'none');
    insertCloseButton({
      buttonClass: 'sticky-ad-close',
      ad: innerContainer,
      parent: container,
      trackValue: 'footer_dsms'
    });

    $(window)
      .one('sticky:close', function(e) {
        $(container).remove();
      })
      .one('sticky:display', function(e) {
        if (expandCount > 0) return;
        $(container)
          .css('display', 'flex')
          .find(`#${adID}`).addClass(ifiLabelClass);
      }).on('sticky:expand', function(e) {
        ++ expandCount;
        const profads = window.profads.ads2;
        const detail = e.originalEvent.detail;
        const overflowClass = 'expand-sticky-visible ';
        const expandContainer = profads.utils.createElement({
          name: 'div',
          id: 'sticky-expand-container',
          className: 'expand-container'
        });
        // setting this data attribute before the div is appended will let internal script know it's ready to be run
        detail.container.setAttribute('data-state', 'ready');
        expandContainer.appendChild(detail.container);

        insertCloseButton({
          buttonClass: 'expand-close',
          ad: expandContainer,
          parent: expandContainer,
          trackValue: 'footer-expand_dsms',
          callBack: function() {
            $(document.body).removeClass(overflowClass);
          }
        });

        $(document.body)
          .addClass(overflowClass)
          .append(expandContainer);
      });

    function insertCloseButton(cfg) {
      const closeBtn = that.utils.createElement({
        name: 'span',
        className: cfg.buttonClass,
        text: 'close'
      });

      cfg.ad.prepend(closeBtn);

      // close handler, removes wrapper and ad from DOM
      $('body').on('click', `.${cfg.buttonClass}`, function(e) {
        $(cfg.parent).remove();
        // track sticky ad close
        wmdPageLink(cfg.trackValue, e.target);
        if (cfg.callBack) cfg.callBack();
      });

      return closeBtn;
    }
  },
  mutationTargets: [],
  addMutationListener: function(config) {
    const mutateConfig = {
      attributes: true,
      childList: true,
      subtree: true
    };
    this.mutationTargets.push(config.target);
    function callback(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type == 'childList' || mutation.target) {
          if (config.callBack) config.callBack();
        }
        else if (mutation.type == 'attributes') { }
      }
    }

    const observer = new MutationObserver(callback);
    observer.observe(config.target, mutateConfig);
    // Later, you can stop observing
    //observer.disconnect();
  },
  /*
     * Function to call, insert an ad based on a config object which specifies the ->
     * adjacent dom node and the id,
     * returns the new ad jQuery element
     * */
  insertAdElement: function(adConfig) {
    ++ this.insertCount;
    const adPos = parseInt(adConfig.pos ? adConfig.pos : adConfig.id);
    const adDiv = `<div id="ads-pos-${adPos}" data-insertnum="${this.insertCount}" class="${this.utils.addClassName}"></div>`;
    const adId = `ads-pos-${adConfig.id}`;
    // the next line calls jQuery's insertBefore or insertAfter method
    //adDiv[adConfig.beforeOrAfter](adConfig.targetElement);

    if (typeof adConfig.targetElement === 'string') {
      var targetEleCheck = document.getElementById(`ads-pos-${adConfig.targetElement}`);
      if (targetEleCheck) {
        adConfig.targetElement = targetEleCheck;
      }
    }
    if (adConfig.beforeOrAfter === 'insertBefore') adConfig.beforeOrAfter = 'beforebegin';
    // check for legacy jQuery target elements
    if (adConfig.targetElement && adConfig.targetElement.length > 0 && typeof adConfig.targetElement == 'object') adConfig.targetElement = adConfig.targetElement[0];

    if (typeof adConfig.targetElement == 'object') adConfig.targetElement.insertAdjacentHTML(adConfig.beforeOrAfter || adConfig.insertionPoint, adDiv);

    let defineObj = {
      id: adId,
      pos: adPos,
      collapseAfter: adConfig.collapseAfter || true,
      immediate: adConfig.immediate,
      internalDefine: adConfig.internalDefine || false
    }

    webmd.ads2.defineAd(defineObj);

    // TODO FOR IMPLEMENTATION LATER...
    /*this.addMutationListener({
         target: document.querySelector(adConfig.id);
         });*/

    return document.querySelector(`#${adId}`);
  },
  /*
    * Display Manufacturers Announcment Layer
    * */
  displayMANLayer: function(adNode) {
    manLayer.call(this, adNode);
  },
  /**
     * Function to call to allow DFP to store Ad key/value pairs to track during virtual page refresh and lazy load.
     * @param pos - the ad pos of the creative that calls this method
     * @param key - the key
     * @param value - the value
     */
  setPageAdVar: function(pos, key, value) {
    if (pos == '122') profads.ads2.pageAdVars[key] = value;
  },
  /**
     * Function to call to retrieve the ASID value for a given pos base on matching the pbr ad size with
     * the possible adslot sizes for a given position
     * Note: if no pbr array exists an empty string is returned
     * @param pos - the pos of the ad slot
     */
  isGDPR: function() {
    if ($.cookie('isgdprct')) {
      return true;
    }
    return false;
  },
  getBrkPnt: function() {
    if (window.innerWidth <= 767) {
      return "320-767";
    } else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {
      return "768-1023";
    } else if (window.innerWidth >= 1024 && window.innerWidth <= 1280) {
      return "1024-1279";
    } else {
      return "1280-greater";
    }
  },
  KillSwitch: function() {
    var killSwRes = false;
    if (typeof PageMetadata !== 'undefined') {
      var enabledDomains = $.trim(PageMetadata.reqHeaders.enableDomain).split(",");
      $(enabledDomains).each(function(index, value) {
        var tempRegEx = new RegExp(value);
        if ($.trim(PageMetadata.reqHeaders.enableDomain) !== '' && tempRegEx.test(pageCurrentURL)) {
          killSwRes = true;
        }
      });
      return killSwRes;
    } else {
      profads.ads2.KillSwitchAjax();
    }
  },
  KillSwitchAjax: function() {
    $.ajax({
      url: '//www' + profads.ads2.SetSubDOMenv() + '.medscape.com/pagemetadata?outputFormat=json&callback=?',
      dataType: 'json',
      success: function(AjaxReturn) {
        AjaxTargetKeys = AjaxReturn;
        if (typeof AjaxTargetKeys !== 'undefined') {
          var enabledDomains = $.trim(AjaxTargetKeys.reqHeaders.enableDomain).split(",");
          $(enabledDomains).each(function(index, value) {
            var tempRegEx = new RegExp(value);
            if ($.trim(AjaxTargetKeys.reqHeaders.enableDomain) !== '' && tempRegEx.test(pageCurrentURL)) {
              profads.ads2.MakeAdCall();
            }
          });
        }
      }
    });
  },
  ProfAdsIgnore: function() {
    // Initialize window.ads2_ignore if it is undefined
    window.ads2_ignore = window.ads2_ignore || {};
    //Always block the 2122 ad until business needs
    window.ads2_ignore["2122"] = "true";
    debug.log("[profads] ProfAdsIgnore method called", window.ads2_ignore);
    if (!_isRecap && !isDD) {
      window.ads2_ignore["145"] = "true";
    }
    if (this.utils.isSlideShow()) {
      if (this.utils.hasEcdQuery() && slideShowVars.infiniteScroll === undefined) window.ads2_ignore['1005'] = 'true';
    }

    // PPE-141220 - Rollback Remove Top Leaderboard Ad (101) for Legacy/Responsive Slideshows (PPE-126189)
    if (PageMetadata.webSegVars.pc == "slideshow") {
      window.ads2_ignore["141"] = "true";
    }
    if (typeof window.ads2_ignore !== "undefined") {
      setTimeout(function() {
        var ignore = window.ads2_ignore;
        if (ignore.all) {
          $('.AdUnit').hide();
        } else {
          var keyPOS = [];
          $.each(window.ads2_ignore, function(index, value) {
            keyPOS.push(index);
          });
          for (var i = 0; i < keyPOS.length; i++) {
            $('#ads-pos-' + keyPOS[i].toString()).hide();
          }
        }
      }, 1000);
    }

    if (PageMetadata.reqHeaders.device == 'MOBILE' || (profads.ads2.getBrkPnt() == '320-767' && PageMetadata.reqHeaders.device !== 'IPAD')) {
      window.ads2_ignore["101"] = "true";
      window.ads2_ignore["420"] = "true";
      window.ads2_ignore["421"] = "true";
      window.ads2_ignore["520"] = "true";
      window.ads2_ignore["910"] = "true";
      window.ads2_ignore["122"] = "true";
      window.ads2_ignore["127"] = "true";
      window.ads2_ignore["141"] = "true";
      window.ads2_ignore["142"] = "true";
      window.ads2_ignore["104"] = "true";
      window.ads2_ignore["970"] = "true";
      window.ads2_ignore["971"] = "true";
      window.ads2_ignore["145"] = "true";
      window.ads2_ignore["909"] = "true";
      window.ads2_ignore["800"] = "true";
      window.ads2_ignore["918"] = "true";
      window.ads2_ignore["919"] = "true";
      window.ads2_ignore["309"] = "true";
    } else if (PageMetadata.reqHeaders.device == 'PC' || PageMetadata.reqHeaders.device == 'IPAD') {
      window.ads2_ignore["1004"] = "true";
      window.ads2_ignore["1005"] = "true";
      window.ads2_ignore["1420"] = "true";
      window.ads2_ignore["1421"] = "true";
      window.ads2_ignore["1520"] = "true";
      window.ads2_ignore["1122"] = "true";
      window.ads2_ignore["2017"] = "true";
      window.ads2_ignore["1522"] = "true";
      window.ads2_ignore["1523"] = "true";
      window.ads2_ignore["1712"] = "true";
      window.ads2_ignore["1970"] = "true";
      window.ads2_ignore["1971"] = "true";
      window.ads2_ignore["1145"] = "true";
      window.ads2_ignore["1909"] = "true";
      window.ads2_ignore["1800"] = "true";
      window.ads2_ignore["1523"] = "true";
      window.ads2_ignore["1918"] = "true";
      window.ads2_ignore["1919"] = "true";
      window.ads2_ignore["1309"] = "true";
    }

    if (pageCurrentURL.indexOf('viewcollection') != -1 && PageMetadata.reqHeaders.device == "MOBILE") {
      window.ads2_ignore["1005"] = "true";
    }

    if (pageCurrentURL.indexOf('case-review') != -1 && PageMetadata.reqHeaders.device == "MOBILE") {
      window.ads2_ignore["1005"] = false;
    }

    if (PageMetadata.lazyLoad != null) {
      if (PageMetadata.lazyLoad.blb != null) {
        if (PageMetadata.lazyLoad.blb && bNews) {
          window.ads2_ignore["141"] = "true";
          lazyLoadBlb.init();
        }
      }
    }
    if (bUse_1520_1122_SwapRules) {
      window.ads2_ignore["1122"] = "true";
    }
    if (PageMetadata.webSegVars.pc === 'rc' && s_responsive_design) {
      window.ads2_ignore["141"] = "true";
      window.ads2_ignore["520"] = "true";
      window.ads2_ignore["420"] = "true";
      window.ads2_ignore["1712"] = "true";
      window.ads2_ignore["1520"] = "true";
      window.ads2_ignore["1420"] = "true";
    }
    if (_isRecap) {
      window.ads2_ignore["101"] = "true";
      window.ads2_ignore["1004"] = "true";
    }

    if (mobOptCheck == "true") {
      window.textDriverOptimized = mobOptCheck;
    }
    if (window.textDriverOptimized) {
      //to prevent page loading ad call for 1420 ad in mobile.
      if (isEmed) {
        window.ads2_ignore["1420"] = "true";
      }
      setTimeout(function() {
        var ads1420Prev = $("#ads-pos-1420").prev()[0];
        if (!ads1420Prev) return;
        if (ads1420Prev.localName == "script") {
          var ads1420PrevP = $("#ads-pos-1420").prev();
          ads1420PrevP.prev().before('<div id="plcHold-1420" class="1420SpcHolder"></div>');
        } else {
          $("#ads-pos-1420").prev().before('<div id="plcHold-1420" class="1420SpcHolder"></div>');
        }
      }, 500);
    }

    if (mobOptCheck == "true") {
      window.textDriverOptimized = mobOptCheck;
    }
    if (window.textDriverOptimized && (_isAnArticle || isEmed)) {
      window.ads2_ignore["1004"] = "true"; // Mob Opt. P1, PPE-200055
      if (breakpoint == 1) {
        //window.ads2_ignore["1145"] = false;
      }
      else {
        window.ads2_ignore["145"] = false;
      }
      if (isEmed && breakpoint == 1) {
        window.ads2_ignore["1004"] = false;  // mob opt PPE-231757
        //window.ads2_ignore["1145"] = "true";
      }
    }
    if (_isRecap && breakpoint == 1) {
      //window.ads2_ignore["1145"] = false;
    }
    if (_isRecap && breakpoint >= 3) {
      window.ads2_ignoreIds['ads-pos-1122-a'] = true;
      let _1122_a_id = 'ads-pos-1122-a';
      profads.ads2.readyFunctions.push(() => {
        document.querySelector(`#${_1122_a_id}`).style.display = 'none';
      });
    }
    if (_isODP) {
      if (PageMetadata.webSegVars.pc == "indexpage") {
        window.ads2_ignoreIds['ads-pos-141_1'] = true;
        let _141_1_id = 'ads-pos-141_1';
        profads.ads2.readyFunctions.push(()=>{
          document.getElementById(`${_141_1_id}`).style.display = 'none';
        });
        if (PageMetadata.reqHeaders.device == 'MOBILE' || profads.ads2.getBrkPnt() == '320-767') {
          window.ads2_ignore["1122"] = false;
          // window.ads2_ignore["1145"] = false;
          window.ads2_ignore["1004"] = "true";
          window.ads2_ignore["1005"] = false;
        } else {
          window.ads2_ignore["101"] = false;
          window.ads2_ignore["141"] = "true";
        }
      }
      if (PageMetadata.webSegVars.pc == "content") {
        if (PageMetadata.reqHeaders.device == 'MOBILE' || profads.ads2.getBrkPnt() == '320-767') {
          // window.ads2_ignore["1145"] = false;
          window.ads2_ignore["1004"] = "true";
          window.ads2_ignore["1005"] = false;
          window.ads2_ignore["1122"] = "true";
        }
        else {
          window.ads2_ignore["101"] = "true";
          window.ads2_ignore["910"] = "true";
          window.ads2_ignore["141"] = "true";
          window.ads2_ignoreIds['ads-pos-141'] = true;
        }
      }
    }
    /* Adding 105,1005 to ads2_ignore on medscape.org qna pages */
    if (/(?=.*medscape\.org)(?=.*qna)/i.test(pageCurrentURL) || document.querySelector('.qna-render')) {
      window.ads2_ignore["1005"] = "true";
      window.ads2_ignore["105"] = "true";
    }
    if (PageMetadata && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype === 20171) {
      if (PageMetadata.reqHeaders.device == "MOBILE" || profads.ads2.getBrkPnt() == "320-767") {
        window.ads2_ignore["309"] = "true";
      } else {
        window.ads2_ignore["1309"] = "true";
      }
    }
    if (PageMetadata && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype) {
      var recapCtypes = [ 10514, 49129, 330138, 650136, 590136 ];
      if (recapCtypes.indexOf(PageMetadata.pageSegVars.ctype) !== -1) {
        window.ads2_ignore["520"] = true;
        window.ads2_ignore["420"] = true;
        window.ads2_ignore["1520"] = true;
        window.ads2_ignore["1420"] = true;
      }
    }

    if (
      PageMetadata.reqHeaders.device == 'MOBILE' &&
            (pageCurrentURL.indexOf('etumor') != -1 ||
                pageCurrentURL.indexOf('mtv') != -1)
    ) {
      window.ads2_ignore['1005'] = false;
    }

    if (DFPTargetKeys.webSegVars.spon === "myinvitation" || DFPTargetKeys.webSegVars.pc === "slideshow") {
      window.ads2_ignore["105"] = true;
    }

    if (PageMetadata.webSegVars.spon === "myinvitation") {
      window.ads2_ignore["145"] = true;
      window.ads2_ignore["1145"] = true;
    }

    if (PageMetadata.pageSegVars.ctype == '10511' && PageMetadata.reqHeaders.device == 'PC') {
      window.ads2_ignore["122"] = "true";
      window.ads2_ignore["127"] = false;
    }
    if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype == "10511" && PageMetadata.reqHeaders.device == 'PC') {
      window.ads2_ignore["141"] = false;
    }
    if (pageCurrentURL.indexOf('medline') != -1) {
      if (PageMetadata.reqHeaders.device == 'MOBILE') {
        window.ads2_ignore["1420"] = "true";
      } else {
        window.ads2_ignore["420"] = "true";
      }
    }
    if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype == 10517) {
      window.ads2_ignore["141"] = "true";
      window.ads2_ignoreIds["ads-pos-141"] = "true";
      window.ads2_ignoreIds["ads-pos-141_1"] = "true";
      window.ads2_ignoreIds["ads-pos-141_2"] = "true";
      $("#plcHold-141,.additional-141").hide();
    }
  },
  adCollideTest: function(adTopPos) {
    if (adTopPos.top < 1100) {
      return Boolean(true);
    } else {
      return Boolean(false);
    }
  },
  ProfAdsDisplay: function(DevTypeObj) {
    webmd.ads2.disableInitialLoad();
    profads.ads2.setSSLKeys();
    try {
      profads.ads2.setPIMC();
    }
    catch (e) {
      debug.log("[profads] Error while setting PIMC");
    }
    getPPID();
    this.staticTargetKeys();
    this.addDynamicTargetKeys();

    if (mobOptCheck == "true") window.textDriverOptimized = mobOptCheck;
    if (isEmed && window.textDriverOptimized && breakpoint == 1) mobAdOptimize.check1520Position();

    if (PageMetadata.pageSegVars.ctype == '10511' && PageMetadata.reqHeaders.device == 'PC') {
      const element = document.querySelector('div[id^="ads-pos-122"]');
      if (element !== null) {
        element.id = 'ads-pos-127';
        webmd.ads2.defineAd({
          id: 'ads-pos-127',
          pos: '127',
          collapseAfter: true
        });
      }
    }
    if (typeof s_responsive_design != 'undefined' && s_responsive_design) {
      profads.ads2.addBrandAlert();

      let _141ResetCalled = false;
      webmd.ads2.addSlotRenderEndedCallback('ads-pos-141', (e) => {
        if (!_141ResetCalled)reset141position();
      });

      function reset141position() {
        // reset position of 141 on tablet on desktop
        const mQuery = window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px)').matches
        let _141;
        const selector = '*[id*="ads-pos-141"]';
        // iterate over all the 141 content columns for different sections of the site
        const _141Parent = [ '.column-left', '.article-column-left', '#rel-links', '#article-content' ].map(p =>{
          return document.querySelector(p);
        }).filter(ele => { return ele != undefined && ele.querySelector(selector) !== null});

        if (_141Parent) {
          _141 = _141Parent.map(p => {
            let ad = p.querySelector(selector);
            if (ad !== null) return ad;
          }).filter((ad, i, arr) => arr[i] !== arr[i + 1]);

          if (_141.length > 0) {
            _141.forEach(ad => {
              // for desktop, else if for tablet
              if (!mQuery && window.breakpoint > 2) ad.style.marginRight = "-32px";
              else if (mQuery) ad.setAttribute('style', 'position: absolute !important');
            });
          }
        }
        _141ResetCalled = true;
      }
      // fallback in case the addSlotRenderEndedCallback fails
      setTimeout(() => {
        if (!_141ResetCalled) reset141position();
      }, 300);
    }
    if (bUse_1520_1122_SwapRules) {

      // unsuppress it
      window.ads2_ignore["1122"] = false;

      // check for 1122 in dom

      $adsPos1122 = $("#ads-pos-1122");

      // if no 1122 in the dom use media unit size when it's defined later
      if ($adsPos1122.length <= 0) {
        webmd.ads2.sizes[1122] = [
          [ 300, 250 ],
          [ 300, 50 ],
          [ 300, 51 ],
          [ 320, 50 ],
          [ 320, 51 ]
        ];
      }

      // if 1122 exist and above 1520, use regular media unit size. Some situations 1122 is above 1522 on reference pages
      else if ($adsPos1122.nextAll("#ads-pos-1520").length > 0) {
        webmd.ads2.sizes[1122] = [
          [ 300, 250 ],
          [ 300, 50 ],
          [ 300, 51 ],
          [ 320, 50 ],
          [ 320, 51 ]
        ];

        // define the 1122 again
        webmd.ads2.defineAd({
          id: 'ads-pos-1122',
          pos: '1122',
          collapseAfter: true
        });
      }

      // if 1122 exist somewhere within the content, use text driver sizes
      else if ($adsPos1122.nextAll("p").length > 0) {
        webmd.ads2.sizes[1122] = [
          [ 1, 5 ],
          [ 300, 253 ]
        ];

        // emedicine / reference articles define the 1122 slot later
        if ($.inArray(PageMetadata.pageSegVars.cg, [ "502", "503", "504", "505", "508" ]) === -1) {
          // define the 1122 again
          webmd.ads2.defineAd({
            id: 'ads-pos-1122',
            pos: '1122',
            collapseAfter: true
          });
        }
      }

      // if 1122 is not somewhere within content use it's default media unit sizes
      else {
        webmd.ads2.sizes[1122] = [
          [ 300, 250 ],
          [ 300, 50 ],
          [ 300, 51 ],
          [ 320, 50 ],
          [ 320, 51 ]
        ];

        if ($.inArray(PageMetadata.pageSegVars.cg, [ "502", "503", "504", "505", "508" ]) === -1) {
          webmd.ads2.defineAd({
            id: 'ads-pos-1122',
            pos: '1122',
            collapseAfter: true
          });
        }
      }

    }
    if (_isODP && PageMetadata.reqHeaders.device == "PC" && PageMetadata.webSegVars.pc == "content") {
      this.insertAdElement({
        id: '800',
        pos: 800,
        collapseAfter: true,
        beforeOrAfter: 'insertBefore',
        targetElement: document.querySelectorAll('.page-body')[0]
      });
    } else if (_isODP && PageMetadata.reqHeaders.device == "MOBILE" && PageMetadata.webSegVars.pc == "content") {
      this.insertAdElement({
        id: '1800',
        pos: 1800,
        collapseAfter: true,
        beforeOrAfter: 'insertBefore',
        targetElement: document.querySelectorAll('.page-body')[0]
      });
    }
    if (isDD) {
      if (this.isDrug() && $('#stick-ad-outter-wrapper').length > 0) {
        this.stickyAd(DevTypeObj.isMobile);
      }
      if (typeof ads2_suppress === "undefined") {
        if (DevTypeObj.isMobile || profads.ads2.getBrkPnt() == '320-767') {

          $('#plcHold-141').remove();

          webmd.ads2.setPageTarget('al', '0');

          if (window.location.hash == "" || $("#content_" + window.location.hash.split('#')[1]).index() == 0) {
            var passIsMob = DevTypeObj.isMobile;
            profads.ads2.ResizeTemplateAds(passIsMob);

          } else {
            delete window.ads2_ignore["1122"];
            delete window.ads2_ignore["1420"];
            delete window.ads2_ignore["1520"];
            window.ads2_ignore["1004"] = "true";
          }
        } else {
          if (document.location.hash == "" && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype != 10517) {

            if ($(".refsection_content").first().has('#ads-pos-141').length == 0) {

              if ($(".refsection_content:eq( 0 ) div.inContentAd:eq( 7 )").length != 0) {

                var inAdPos = $(".refsection_content:eq( 0 ) div.inContentAd:eq( 7 )").position();
                if (profads.ads2.adCollideTest(inAdPos)) {
                  webmd.ads2.setPageTarget('al', 'bl_mid');
                  $("#rel-links").prepend('<div class="adSpcHolder"><div id="ads-pos-141" class="AdUnit"></div></div>');
                } else {
                  webmd.ads2.setPageTarget('al', 'bl_high');
                  $(".refsection_content:eq( 0 ) div.inContentAd:eq( 7 )").append('<div class="adSpcHolder"><div id="ads-pos-141" class="AdUnit"></div></div>');
                }

              } else {
                webmd.ads2.setPageTarget('al', 'bl_low');
                $("#rel-links").prepend('<div class="adSpcHolder"><div id="ads-pos-141" class="AdUnit"></div></div>');
              }
              webmd.ads2.defineAd({ id: 'ads-pos-141', pos: 141 });
            } else {
              var inAdPos = $("#plcHold-141").position();
              webmd.ads2.setPageTarget('al', 'bl_high');
              if (profads.ads2.adCollideTest(inAdPos)) {
                webmd.ads2.setPageTarget('al', 'bl_mid');
                $("#plcHold-141").remove();
                $("#rel-links").prepend('<div class="adSpcHolder"><div id="ads-pos-141" class="AdUnit"></div></div>');
              }
            }
          } else {
            window.ads2_ignore["141"] = "true";
            window.ads2_ignore["520"] = "true";
            window.ads2_ignore["420"] = "true";
          }

          var passIsMob = DevTypeObj.isMobile;
          profads.ads2.ResizeTemplateAds(passIsMob);
        }
      }

      if (DevTypeObj.isDesktop || DevTypeObj.isTablet) {
        profads.ads2.desktopAdPositioning();
      }
    } else {
      if (s_responsive_design && (_isAnArticle || _isRecap) && PageMetadata.reqHeaders.domainCategory != 'cme') {
        if (DevTypeObj.isMobile || profads.ads2.getBrkPnt() == '320-767') $('#plcHold-141').remove();

        if (window.location.hash == "" && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype != 10517) {

          // If is breakpoint 2 or 3
          if (profads.ads2.getBrkPnt() === '768-1023' || profads.ads2.getBrkPnt() === '1024-1279') {
            if ($("#plcHold-141").length !== 0) {
              var inAdPos = $("#plcHold-141").position();
              if (profads.ads2.adCollideTest(inAdPos)) {
                $("#plcHold-141").remove();
                webmd.ads2.setPageTarget('al', 'bl_low');
                $("#rel-links").prepend('<div class="adSpcHolder"><div id="ads-pos-141" class="inLine141 AdUnit"></div></div>');
              }
              else {
                webmd.ads2.setPageTarget('al', 'bl_high');
              }
            }
          }
          else if (profads.ads2.getBrkPnt() === '1280-greater') { // If is breakpoint 4
            if ($("#plcHold-141").length !== 0) {
              webmd.ads2.setPageTarget('al', 'bl_high');
            }
          }

          // If 141 does not exist
          if ($('div[id^="ads-pos-141"]').length === 0 && ads2_ignore.all != "true" && PageMetadata.reqHeaders.device != "MOBILE" && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype != 10517) {
            webmd.ads2.setPageTarget('al', 'bl_low');
            if ($('#rel-links').length === 0) {
              $('div#rel-links-container').last().prepend('<div class="adSpcHolder additional-141"><div class= "AdUnit" id="ads-pos-141"></div></div><div id="rel-links"></div>');
            } else {
              $('div#rel-links-container').last().prepend('<div class="adSpcHolder additional-141"><div class= "AdUnit" id="ads-pos-141"></div></div>');
            }
            webmd.ads2.defineAd({ id: 'ads-pos-141', pos: '141' });
          }
          if (typeof breakpoint != 'undefined' && breakpoint == 1) webmd.ads2.setPageTarget('al', '0'); // set the initial al to empty for bp1
        }
      } else {
        if (_isAnArticle && PageMetadata.reqHeaders.domainCategory != 'cme') {

          if (DevTypeObj.isMobile) {
            if (!$('#ads-pos-1122').length > 0 && !isMscpApp && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype != 10517) {
              // If no 1122 of page load add 1122 above sharelinks
              $('<div id="ads-pos-1122" class="AdUnit"></div>').insertBefore($("#abBottom"));
              if ($('#ads-pos-1122').length > 0) {
                webmd.ads2.defineAd({
                  id: 'ads-pos-1122',
                  pos: '1122',
                  collapseAfter: true
                });
              }
              // add noAd marker on last two placeholders in they're appear on same screen
              if ($(".incontentAdUnit").length != 0 && $("#ads-pos-1122").offset().top - $(".incontentAdUnit").eq(-1).offset().top < $(window).height()) {
                $(".incontentAdUnit").eq(-1).addClass("noAdDiv");
                if ($("#ads-pos-1122").offset().top - $(".incontentAdUnit").eq(-2).offset().top < $(window).height()) {
                  $(".incontentAdUnit").eq(-2).addClass("noAdDiv");
                }
              }
            }

          } else {
            //Desktop Non-Responsive

          }
        }
        else if (PageMetadata.webSegVars.pc === 'hp' && s_responsive_design && pageCurrentURL.indexOf('emedicine') == -1 && pageCurrentURL.indexOf('reference') == -1) {
          webmd.ads2.disableInitialLoad();
          if (typeof ads2_suppress === "undefined") {
            if (DevTypeObj.isMobile || profads.ads2.getBrkPnt() == '320-767') {
            } else {
              $(".page-body section").not(".hp_alerts").eq(4).after("<div id='ads-pos-141' class='AdUnit'></div>");
              webmd.ads2.defineAd({ id: 'ads-pos-141', pos: '141' });
            }
          }

        }
        else {
        }
        if (DevTypeObj.isDesktop || DevTypeObj.isTablet) {
          profads.ads2.desktopAdPositioning();
        }
        var passIsMob = DevTypeObj.isMobile;
        profads.ads2.ResizeTemplateAds(passIsMob);
      }
    }
    // use original media unit sizes for lazyloaded 1122.
    if (bUse_1520_1122_SwapRules) {
      webmd.ads2.sizes[1122] = [
        [ 300, 250 ],
        [ 300, 50 ],
        [ 300, 51 ],
        [ 320, 50 ],
        [ 320, 51 ]
      ];
    }
    if (s_responsive_design) {
      //starting to handle hiding ad labels for responsive
      if (PageMetadata.reqHeaders.device == 'MOBILE' || profads.ads2.getBrkPnt() == '320-767') {
        $('#ads-pos-420').hide();
        $('#ads-pos-520').hide();
        $('#ads-pos-122').hide();
        $('#ads-pos-910').hide();
        $('#ads-pos-101').hide();
        $('#ads-pos-104').hide();
        $('#ads-pos-141').hide();
        $('#ads-pos-421').hide();
        $('#ads-pos-145').hide();

        // share-through slots
        $('#ads-pos-141-sfp').hide();
        $('#ads-pos-142-sfp').hide();
        $('#ads-pos-420-sfp').hide();
        $('#ads-pos-421-sfp').hide();
        $('#ads-pos-520-sfp').hide();
        $('#ads-pos-970-sfp').hide();
        $('#ads-pos-971-sfp').hide();
      } else if (PageMetadata.reqHeaders.device == 'PC' || PageMetadata.reqHeaders.device == 'IPAD') {
        $('#ads-pos-1420').hide();
        $('#ads-pos-1421').hide();
        $('#ads-pos-1520').hide();
        $('#ads-pos-1122').hide();
        $('#ads-pos-1004').hide();
        $('#ads-pos-1005').hide();
        $('#ads-pos-2017').hide();
        $('#ads-pos-1145').hide();

        // share-through slots
        $('#ads-pos-1420-sfp').hide();
        $('#ads-pos-1421-sfp').hide();
        $('#ads-pos-1520-sfp').hide();
        $('#ads-pos-1712-sfp').hide();
        $('#ads-pos-1970-sfp').hide();
        $('#ads-pos-1971-sfp').hide();
      }
    }
    $('div[id^="ads-"]').addClass("globalpromoadsunit"); //add classname
    debug.log('[profads] Before Display method called');
    if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype == 10517) {
      window.ads2_ignore["141"] = "true";
      window.ads2_ignoreIds["ads-pos-141"] = "true";
      window.ads2_ignoreIds["ads-pos-141_1"] = "true";
      window.ads2_ignoreIds["ads-pos-141_2"] = "true";
      $("#plcHold-141,.additional-141").hide();
    }
    webmd.ads2.display();
    debug.log('[profads] Before refresh method called');
    webmd.ads2.refresh();

  },
  MakeAdCall: function() {
    var adself = this;
    // Do a check to make sure nobody tries to run this twice,
    if (adself.MakeAdCall.flag) {
      return;
    }
    adself.MakeAdCall.flag = true;

    var DevTypeObj = {};
    var SubD_D_Obj = {};

    profads.ads2.TestAdUnitL1L2(profads.ads2.DetectUA(DevTypeObj), profads.ads2.DetectSubD_D(SubD_D_Obj));

    //Build Exclusion List
    profads.ads2.ExclusionList(SubD_D_Obj);

    // Set page targets for all ads
    webmd.ads2.setPageTarget(profads.ads2.CapTargetKeys());

    document.onreadystatechange = () => {
      if (document.readyState === "complete") {
        if (typeof visitor === 'undefined') {
          document.addEventListener('visitorIdSet', function() {
            webmd.ads2.setPageTarget("oid", visitor.getMarketingCloudVisitorID());
            profads.ads2.ProfAdsDisplay(DevTypeObj);
          });
        } else {
          webmd.ads2.setPageTarget("oid", visitor.getMarketingCloudVisitorID());
          profads.ads2.ProfAdsDisplay(DevTypeObj);
        }
        if (DevTypeObj.isMobile) profads.ads2.mobileAdPlacement();

        // trigger profads ready event
        const profAdsReadyEvent = new CustomEvent('profadsready');
        window.dispatchEvent(profAdsReadyEvent);
      }
    }

    var currentURL = window.location.href;
  },
  mobileAdPlacement: function() {
    if (PageMetadata.webSegVars.pc === 'hp' && !s_responsive_design) {
      if ($('#specialtyNews ul li').length > 1) {
        if ($(".businessmedicine").length > 0) {
          $('#perspective ul li:eq(1)').after('<div id="ads-pos-1122" class="AdUnit"></div>');
        } else {
          $('#specialtyNews ul li:eq(1)').after('<div id="ads-pos-1122" class="AdUnit"></div>');
        }
        //   if($('#specialtyNews .bucketL ul li').length > 0) {
        //       $('#specialtyNews .bucketL ul li:eq(0)').after('<div id="ads-pos-1122" class="AdUnit"></div>');
      } else {
        if ($("#tools").length != 0) {
          $("#tools").after('<div id="ads-pos-1122" class="AdUnit"></div>');
        } else {
          $("#bodypadding").append('<div id="ads-pos-1122" class="AdUnit"></div>');
        }
      }
      webmd.ads2.defineAd({
        id: 'ads-pos-1122',
        pos: '1122',
        collapseAfter: true
      });
      setTimeout(function() {
        var shouldMoveBA = false;
        if ($('#specialtyNews .bucketL ul > li:eq(2)').hasClass("brandAlert") && !profads.ads2.isEmpty($('#ads-pos-1122 iframe').contents().find("body"))) {
          if ($('#ads-pos-1122 iframe').contents().find("body#ProfBlankAd").length == 0) {
            var firstBA = $('#specialtyNews .bucketL ul > li:eq(2)');
            //  var firstBA = $('#specialtyNews  li).eq(2)');
            $('#specialtyNews .bucketL ul > li:eq(2)').remove();
            if ($('#specialtyNews .bucketL ul > li:eq(2)').length > 0) {
              $('#specialtyNews .bucketL ul > li:eq(2)').after(firstBA);
            } else {
              $('#specialtyNews .bucketR ul > li:eq(0)').after(firstBA);
            }
            shouldMoveBA = true;
          }
        }
        if (shouldMoveBA) {
          var secondBA = $('ul li:eq(1).brandAlert');
          $('ul li:eq(1).brandAlert').remove();
          if ($('#specialtyNews .bucketL ul > li:eq(3)').length > 0) {
            $('#specialtyNews .bucketR ul > li:eq(1)').after(secondBA);
          } else {
            $('#specialtyNews .bucketR ul > li:eq(4)').after(secondBA);
          }
        }
      }, 1750);
    } else if (pageCurrentURL.indexOf('viewcollection') != -1 && $('.confsection').length > 0 && PageMetadata.reqHeaders.device == "MOBILE" && !isMscpApp) {
      window.ads2_ignore = {};
      webmd.ads2.sizes[1005] = [
        [ 1, 2 ],
        'fluid'
      ];
      webmd.ads2.sizes[1122] = [
        [ 300, 250 ],
        [ 300, 50 ],
        [ 300, 51 ],
        [ 320, 50 ],
        [ 320, 51 ]
      ];
      if ($('.confsection').length == 1) {
        $('.confsection li:eq(1)').after('<div id="ads-pos-1122" class="AdUnit" style="padding-bottom: 7px"></div>');
      } else {
        $('.confsection:eq(0)').after('<div id="ads-pos-1122" class="AdUnit"></div>');
      }
      webmd.ads2.defineAd({
        id: 'ads-pos-1122',
        pos: '1122',
        collapseAfter: true
      });
      webmd.ads2.defineAd({
        id: 'ads-pos-1005',
        pos: '1005',
        collapseAfter: true
      });

    }
  },
  desktopAdPositioning: function() {
    if (pageCurrentURL.indexOf('medline') !== -1 && !(_isAnArticle)) {
      if ($('#ads-pos-420').length > 0) {
        $('#ads-pos-420').hide();
        setTimeout(function() {
          if (($('#articlecontent').height() >= 500 && $('#articlecontent > *').length >= 9) || $('#hidden1').prev().outerHeight(true) >= 250) {
            $('#ads-pos-420').hide();
            let runningHght = 0;
            let goalHght = 250;
            var $artContKids = $('#articlecontent > *');
            for (var adPos = ($artContKids.length - 4); runningHght < goalHght; adPos--) {
              runningHght += $artContKids.eq(adPos).outerHeight();
            }
            var iF420Name = $('#ads-pos-420 iframe').attr("id");
            var longFormContent = $('#ads-pos-420 iframe').contents().find("body").html();
            $('#ads-pos-420 iframe').contents().find("body").empty();
            var links = document.getElementById(iF420Name).contentWindow.document.getElementsByTagName('link');
            $(links).each(function() {
              if ($(this).attr('href').indexOf('ads') != -1) {
                var txtLongCSSpath = $(this).attr('href');
                $("head").append('<link rel="stylesheet" href="' + txtLongCSSpath + '" type="text/css" media="all">');
              }
            });
            $('<span id="medline420"></span>').insertAfter($('#articlecontent > *:eq(' + adPos + ')'));
            $('#medline420').css('float', 'right').css('margin', '0  5px 10px 10px');
            $('#medline420').html(longFormContent);

          } else {
            $('#ads-pos-420').show();
          }
        }, 1500);
      }
    } else if (pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
      if (!s_responsive_design) {
        setTimeout(function() {
          if ($('#ads-pos-420').length > 0) {

            if ($('#ads-pos-420').position().top < $('#leftnav').outerHeight(true) + $('#leftnav').position().top) {
              if ($('#ads-pos-420 iframe').contents().find("div#textDriverLong").length > 0) {
                $('#ads-pos-420').hide();
                var iF420Name = $('#ads-pos-420 iframe').attr("id");
                var longFormContent = $('#ads-pos-420 iframe').contents().find("div#textDriverLong");
                var links = document.getElementById(iF420Name).contentWindow.document.getElementsByTagName('link');
                $(links).each(function() {
                  if ($(this).attr('href').indexOf('long') != -1) {
                    var txtLongCSSpath = $(this).attr('href');
                    $("head").append('<link rel="stylesheet" href="' + txtLongCSSpath + '" type="text/css" media="all">');
                  }
                });
                $('<div class="spacer"></div><div id="btm420"></div>').insertAfter($('.drugdbsectioncontent'));
                $('#ads-pos-420').html('');
                $('#btm420').html(longFormContent);
              }
            }
          }
        }, 1500);
      }
    }
  },
  isEmpty: function(el) {
    this.utils.isEmpty(el);
  },
  isElementVisible: function(elementToBeChecked) {
    var TopView = $(window).scrollTop();
    var BotView = TopView + $(window).height();
    var TopElement = $(elementToBeChecked).offset().top;
    var BotElement = TopElement + $(elementToBeChecked).height();
    return ((BotElement <= BotView) && (TopElement >= TopView));
  },
  calcBottomArtCont: function(ipn) {
    var i = 0,
      runningHght = 0,
      goalHght = 115;
    var $artContKids;

    if ($('div[id^=pageN_]').length > 0) {
      $artContKids = $('#articleContent > #pageN_' + ipn + ' > *');
    } else {
      $artContKids = $('#articleContent > *');
    }
    for (i = $artContKids.length; runningHght < goalHght; i--) {
      runningHght += $artContKids.eq(i).height();
    }
    return $artContKids[i];
  },
  ResizeTemplateAds: function(isMob) {
    if (isMob) {
      $(document).one('dfpRenderComp', function() {
        setTimeout(function() {
          if ($('#ads-pos-2017').length > 0) {

            var pos2017ifrm = $('#ads-pos-2017 iframe');

            if (pos2017ifrm.contents().find("#gne_services_link").length > 0) {
              setTimeout(function() {
                pos2017ifrm.attr('width', '100%');

                var adHeight = pos2017ifrm.contents().find("#gne_services_link").children('div').outerHeight();
                pos2017ifrm.attr('height', adHeight);
              }, 250);
            } else if (pos2017ifrm.contents().find("#pfizercorp_services_link").length > 0) {
              setTimeout(function() {
                pos2017ifrm.attr('width', '100%');

                var adHeight = pos2017ifrm.contents().find("#pfizercorp_services_link").children('div').outerHeight();
                pos2017ifrm.attr('height', adHeight);
              }, 250);
            }
          }
        }, 1500);
      });
    } else {
      $(document).one('dfpRenderComp', function() {
        setTimeout(function() {
          if ($('#ads-pos-421').length > 0) {

            var pos421ifrm = $('#ads-pos-421 iframe');

            if (pos421ifrm.contents().find("#gne_services_link").length > 0) {
              setTimeout(function() {
                pos421ifrm.attr('width', '660');

                var adHeight = pos421ifrm.contents().find("#gne_services_link").outerHeight();
                if (s_responsive_design) {
                  pos421ifrm.attr('height', '100%');
                  pos421ifrm.css('height', '100%');
                  pos421ifrm.attr('width', '100%');
                  pos421ifrm.contents().find("body").attr('style', 'width:auto;');
                  pos421ifrm.contents().find("div#ref_sponsorbox").attr('style', 'width:auto;');
                  pos421ifrm.contents().find("div#ref_sponsorbox .ref_sponsortitle").attr('style', 'width:55%;');
                  pos421ifrm.contents().find("div#image").attr('style', 'margin-top:-50px; margin-right: 8px;');
                  $('#adSpaceMfs').css('min-height', '2.5%');
                } else {
                  pos421ifrm.attr('height', adHeight);
                }
              }, 250);
            } else if (pos421ifrm.contents().find("#pfizercorp_services_link").length > 0) {
              setTimeout(function() {
                pos421ifrm.attr('width', '660');

                var adHeight = pos421ifrm.contents().find("#pfizercorp_services_link").outerHeight();
                if (s_responsive_design) {
                  pos421ifrm.attr('height', '100%');
                  pos421ifrm.css('height', '100%');
                  pos421ifrm.attr('width', '100%');
                  pos421ifrm.contents().find("body").attr('style', 'width:auto;');
                  pos421ifrm.contents().find("div#ref_sponsorbox").attr('style', 'width:auto;');
                  pos421ifrm.contents().find("div#ref_sponsorbox .ref_sponsortitle").attr('style', 'width:55%;');
                  pos421ifrm.contents().find("div#image").attr('style', 'margin-top:-50px; margin-right: 8px;');
                  $('#adSpaceMfs').css('min-height', '2.5%');

                } else {
                  pos421ifrm.attr('height', adHeight);
                }
              }, 250);
            }

          }
        }, 1500);
      });
    }
  },
  ExclusionList: function(SubD_D_Obj) {
    var ExCList = $.merge($.merge(profads.ads2.PageExclusion(), profads.ads2.SSGexclusion(SubD_D_Obj)), profads.ads2.gdprExclusion());
    if (ExCList.length > 0) {
      debug.log("[profads] ExclusionList", ExCList);
      webmd.ads2.setPageExclusion(ExCList);
    }
  },
  PageExclusion: function() {
    var PExVal = [];
    if (typeof PageMetadata !== "undefined") {
      PExVal = PageMetadata.exclusionCategories;
    } else if (typeof AjaxTargetKeys !== "undefined") {
      PExVal = AjaxTargetKeys.exclusionCategories;
    }
    if (!profads.ads2.GDPR_optin_check()) {
      PExVal.push('limited');
    }
    return PExVal;
  },
  SSGexclusion: function(SubD_D_Obj) {
    var SSGWebVars;
    var SSGTPageVars;
    var SSGBol;
    if (SubD_D_Obj.ProfEdu || SubD_D_Obj.ProfEduFR || SubD_D_Obj.ProfEduDE || SubD_D_Obj.ProfEduES) {
      SSGBol = [ "ssg" ];
      return SSGBol;
    } else if (locale == "fr" || locale == "de" || locale == "es" || locale == "pt") {

      if (PageMetadata.webSegVars.pc == "slideshow" || PageMetadata.webSegVars.pc == "content") {
        SSGBol = [ "ssg" ];
        return SSGBol;
      }
      else {
        SSGBol = [ "" ];
        return SSGBol;
      }
    } else {

      if (typeof PageMetadata !== "undefined") {
        SSGWebVars = PageMetadata.webSegVars;
        SSGTPageVars = PageMetadata.pageSegVars;
      } else if (typeof AjaxTargetKeys !== "undefined") {
        SSGWebVars = AjaxTargetKeys.webSegVars;
        SSGTPageVars = AjaxTargetKeys.pageSegVars;
      }
      if (typeof SSGWebVars !== "undefined" && typeof SSGTPageVars !== "undefined") {
        if (SSGWebVars.pc === 'hp' || SSGWebVars.pc === 'rc' || SSGWebVars.pc === 'medline' || SSGWebVars.pc === 'news-today' || SSGTPageVars.cg === '501') {
          SSGBol = [ "ssg" ];
        } else {
          SSGBol = [];
        }
        return SSGBol;
      }
    }
  },
  gdprExclusion: function() {
    var GDPRBol = [ "gdpr0" ];

    if (profads.ads2.isGDPR()) {
      GDPRBol = [ "gdpr1" ];
    }
    return GDPRBol;
  },
  DfpUatCap: function() {
    var urlQstringCap = window.location.href.split('?');
    var QVals = [];
    var KeyValPs = urlQstringCap[1].split("&");
    var TestAdObj = {};
    for (var i = 0; i < KeyValPs.length; i++) {
      QVals[i] = KeyValPs[i].split('=');
      TestAdObj[QVals[i][0]] = QVals[i][1];
    }
    var DfpUatVals = {
      tar: TestAdObj.tar,
      tc: TestAdObj.tc,
      pf: TestAdObj.pf,
      /*ssp:TestAdObj.ssp,ct:TestAdObj.ct,st:TestAdObj.st,*/
      usp: TestAdObj.usp,
      occ: TestAdObj.occ,
      val: TestAdObj.val
    };
    if (TestAdObj.hasOwnProperty("dt")) {
      DfpUatVals.dt = TestAdObj.dt;
    }
    return DfpUatVals;
  },
  getParam: function(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
  getECD: function() {
    var ecd = 0;
    var exDate = new Date();
    exDate.setTime(exDate.getTime() + (120 * 60 * 1000));
    if (profads.ads2.getParam('ecd')) {
      ecd = profads.ads2.getParam('ecd');
      $.cookie('prf_ecd', profads.ads2.getParam('ecd'), { domain: '.medscape.com', path: '/', expires: exDate });
    } else if ($.cookie('prf_ecd')) {
      ecd = $.cookie('prf_ecd');
    }
    return ecd;
  },
  proclivityRefresh: function(id, adID) {
    webmd.ads2.defineAd({
      id: adID,
      pos: '1122',
      immediate: true,
      collapseAfter: true
    });
    return;
  },
  proApiUrl: function() {
    var proApiUrl;
    if (PageMetadata.webSegVars.envp === 'prod') {
      proApiUrl = "api.medscape.com/adpredictionservice/transform";
    } else if (PageMetadata.webSegVars.envp === 'qa00') {
      proApiUrl = "api.qa00.medscape.com/adpredictionservice/transform";
    } else if (PageMetadata.webSegVars.envp === 'qa01') {
      proApiUrl = "api.qa01.medscape.com/adpredictionservice/transform"
    } else if (PageMetadata.webSegVars.envp === 'qa02') {
      proApiUrl = "api.qa02.medscape.com/adpredictionservice/transform";
    } else {
      proApiUrl = "api.medscape.com/adpredictionservice/transform";
    }
    return proApiUrl;
  },
  medscapeRefresh: function() {
    if (enableME) {
      oldPositions = {};
    }
    webmd.ads2.refresh();
    return;
  },
  proclivityKeys: function() {
    var q = {};
    var tempDfpData = {};
    var pSegVar = {};
    var reqHeads = {};
    var uSegVar = {};
    var WSegVar = {};

    if (typeof PageMetadata !== "undefined") {
      var pSetKeys = PageMetadata;
    } else if (typeof AjaxTargetKeys !== "undefined") {
      var pSetKeys = AjaxTargetKeys;
    }
    if (typeof pSetKeys !== "undefined") {
      pSegVar.art = pSetKeys.pageSegVars.art;
      pSegVar.cg = pSetKeys.pageSegVars.cg;
      pSegVar.pub = pSetKeys.pageSegVars.pub;
      pSegVar.scg = pSetKeys.pageSegVars.scg;
      pSegVar.ssp = pSetKeys.pageSegVars.ssp;
      reqHeads.device = pSetKeys.reqHeaders.device;
      reqHeads.domain = pSetKeys.reqHeaders.domain;
      reqHeads.domainCategory = pSetKeys.reqHeaders.domainCategory;
      reqHeads.ep = pSetKeys.reqHeaders.ep;

      var subDOMenv = profads.ads2.SetSubDOMenv();
      var kwKeys = {};
      /* Capture The User Search Term for Key Word targeting key */
      var ProfSearchDOM = new RegExp('search' + subDOMenv + '.medscape.com');
      if (ProfSearchDOM.test(pageCurrentURL)) {
        if (window.location.search.length > 1) {
          var KeyValPs = [];
          var QVals = [];
          KeyValPs = window.location.search.substr(1, window.location.search.length).split("&");
          for (var i = 0; i < KeyValPs.length; i++) {
            QVals[i] = KeyValPs[i].split('=');
            if (QVals[i][0] === 'q') {
              kwKeys.kw = QVals[i][1].replace(/%20/g, ' ');
            }
            else if (QVals[i][0] === 'queryText') {
              kwKeys.kw = QVals[i][1].replace(/\+/g, ' ');
            }
          }
        }
      }
      else {
        kwKeys.kw = '';
      }
      reqHeads = $.extend({}, reqHeads, kwKeys);

      uSegVar.pf = pSetKeys.userSegVars.pf;
      uSegVar.usp = pSetKeys.userSegVars.usp;
      if (typeof pSetKeys.userSegVars.dt !== "undefined") {
        uSegVar.dt = pSetKeys.userSegVars.dt;
      }

      WSegVar.pc = pSetKeys.webSegVars.pc;
      WSegVar.spon = pSetKeys.webSegVars.spon;

      tempDfpData.pageSegVars = pSegVar;
      tempDfpData.reqHeaders = reqHeads;
      tempDfpData.userSegVars = uSegVar;
      tempDfpData.webSegVars = WSegVar;

      q.dfpData = tempDfpData;
    }
    return q;
  },
  CapTargetKeys: function(TKeysObj) {
    var subDOMenv = profads.ads2.SetSubDOMenv();

    if (typeof PageMetadata !== "undefined") {
      /* set pc for Recap*/
      if (_isRecap) PageMetadata.webSegVars.pc = "recap";

      TKeysObj = $.extend({}, PageMetadata.userSegVars, PageMetadata.pageSegVars);

      TKeysObj = $.extend({}, TKeysObj, PageMetadata.webSegVars);

      TKeysObj.ep = PageMetadata.reqHeaders.ep;

    } else if (typeof AjaxTargetKeys !== "undefined") {

      TKeysObj = $.extend({}, AjaxTargetKeys.userSegVars, AjaxTargetKeys.pageSegVars);

      TKeysObj = $.extend({}, TKeysObj, AjaxTargetKeys.webSegVars);

      TKeysObj.ep = AjaxTargetKeys.reqHeaders.ep;

    }

    /* Test for Directory Target Keys */
    var ProfDirDOM = new RegExp('directory' + subDOMenv + '.medscape.com');
    if (ProfDirDOM.test(pageCurrentURL)) {
      if (typeof DirTargetKeys !== "undefined") {
        TKeysObj.spon = DirTargetKeys.webSegVars.spon;
      }
    }

    TKeysObj.pvid = s_pageview_id;

    /* Capture The User Search Term for Key Word targeting key */
    var ProfSearchDOM = new RegExp('search' + subDOMenv + '.medscape.com');
    if (ProfSearchDOM.test(pageCurrentURL)) {
      if (window.location.search.length > 1) {
        var KeyValPs = [];
        var QVals = [];
        KeyValPs = window.location.search.substr(1, window.location.search.length).split("&");
        for (var i = 0; i < KeyValPs.length; i++) {
          QVals[i] = KeyValPs[i].split('=');
          if (QVals[i][0] === 'q') {
            TKeysObj.kw = QVals[i][1].replace(/%20/g, ' ');
          }
          else if (QVals[i][0] === 'queryText') {
            TKeysObj.kw = QVals[i][1].replace(/\+/g, ' ');
          }
        }
      }
      if (window.location.pathname.indexOf('/search') != -1) {
        TKeysObj['sssp'] = TKeysObj['ssp'];
        TKeysObj['sscg'] = TKeysObj['scg'];
        delete TKeysObj['ssp'];
        delete TKeysObj['scg'];
      }
    }

    TKeysObj.stick = '0';
    if (PageMetadata.reqHeaders.domainCategory != 'cme' && PageMetadata.reqHeaders.device == 'PC') {
      if (pageCurrentURL.indexOf('viewarticle') !== -1) {
        TKeysObj.stick = '7,31';
      }
      else if (PageMetadata.webSegVars.pc.indexOf('slideshow') !== -1) {
        if (locale == 'us') {
          TKeysObj.stick = '23';
        }
      }
      else if (PageMetadata.pageSegVars.art != "0") {
        if (pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
          TKeysObj.stick = '16,41';
          if (typeof s_test1 !== 'undefined') {
            if (s_test1 == "ott-tlb_ctrl")
              TKeysObj.stick = '51,41';
            else if (s_test1 == "ott-tlb_test1")
              TKeysObj.stick = '52,41';
          }
        }
      }
    }
    else if (typeof breakpoint != 'undefined' && breakpoint == 1) {
      if (pageCurrentURL.indexOf('viewarticle') !== -1) {
        TKeysObj.stick = '61';
      }
      else if (pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
        TKeysObj.stick = '71';
      }
    }
    if (pageCurrentURL.indexOf('mtv') !== -1) {
      if (PageMetadata.reqHeaders.device == 'MOBILE') {
        TKeysObj.stick = '61';
      } else if (PageMetadata.reqHeaders.device == 'PC') {
        TKeysObj.stick = '63';
      } else if (PageMetadata.reqHeaders.device == 'IPAD') {
        TKeysObj.stick = '62';
      } else {
        TKeysObj.stick = '63';
      }
    }
    // add GDPR value to segvars PPE-151327
    TKeysObj.xgdp = '0';
    if (profads.ads2.isGDPR())  TKeysObj.xgdp = '1';
    //check if accept essentials was opted in by user
    if (!profads.ads2.GDPR_optin_check()) {
      TKeysObj.xgdp = '1';
    }
    // pass msi parameter to the ad call to determine the test and experience
    if (PageMetadata.reqHeaders.domainCategory != 'cme' && PageMetadata.reqHeaders.device == 'MOBILE') {
      if (PageMetadata.webSegVars.pc.indexOf('slideshow') !== -1) {
        if (typeof s_test2 !== 'undefined') {
          if (s_test2 == "ott-msi_ctrl")
            TKeysObj.msi = '0';
          else if (s_test2 == "ott-msi_test1")
            TKeysObj.msi = '1';
          else if (s_test2 == "ott-msi_test2")
            TKeysObj.msi = '2';
          else if (s_test2 == "ott-msi_test3")
            TKeysObj.msi = '3';
        } // end if
      } // end if
    } // end if

    // non virtual page
    TKeysObj.vp = '0';

    if (window.location.href.indexOf("DfpUat") !== -1) {
      var NewUATVals = profads.ads2.DfpUatCap();
      TKeysObj.occ = NewUATVals.occ;
      TKeysObj.pf = NewUATVals.pf;
      TKeysObj.tar = NewUATVals.tar;
      TKeysObj.tc = NewUATVals.tc;
      if (NewUATVals.usp !== '0') {
        TKeysObj.usp = NewUATVals.usp;
      }
      if (NewUATVals.hasOwnProperty("dt")) {
        TKeysObj.dt = NewUATVals.dt;
      }

      TKeysObj.val = NewUATVals.val;
    }
    if (s_responsive_design) TKeysObj.bp = profads.ads2.getBrkPnt();

    Object.keys(TKeysObj).forEach((obj) => {
      TKeysObj[obj] = profads.ads2.utils.cleanTargetKey(TKeysObj[obj]);
    });

    // delete pbr and data passed inside to prevent them from being passed to cust_params
    delete TKeysObj.pdi;
    delete TKeysObj.pbs;
    delete TKeysObj.pdp;
    delete TKeysObj.pbp;
    delete TKeysObj.pds;
    delete TKeysObj.pb;


    return TKeysObj;
  },
  getPageNumber: function() {
    var pageNumber = 1;
    if (_isAnArticle) {
      var getPathName = window.location.pathname;
      var splitPathName = getPathName.split('/');
      var splitArticleId = splitPathName[2].split('_');

      if (splitArticleId[1] === undefined) {
        pageNumber = 1;
      }
      else {
        pageNumber = splitArticleId[1];
      }
    }
    else {
      pageNumber = 1;
    }
    return pageNumber;
  },
  getUrlVars: function() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
    return vars;
  },
  uniqueArray: function(value, index, self) {
    return self.indexOf(value) === index;
  },
  getSAF: function(data) {
    let cookieName = 'ads_saf';
    let cookieValue = data.saf;
    document.cookie = cookieName + "=" + cookieValue + ";domain=.medscape.com;path=/";
    webmd.ads2.setPageTarget('saf', cookieValue);
  },
  getLineItemId: function(data) {
    var lid = data.lid;
    var matched = sessionStorage.getItem('matched');
    var getLid = sessionStorage.getItem('lid');
    var correlator = sessionStorage.getItem("correlator");
    if (data.lid !== null && matched !== "1" && (correlator === null || correlator == googletag.pubads().getCorrelator())) {
      sessionStorage.setItem("correlator", googletag.pubads().getCorrelator());
      sessionStorage.setItem("lid", lid);
      webmd.ads2.setPageTarget('lif', lid);
    }
    else {
      webmd.ads2.setPageTarget('lif', getLid);
    }
  },
  lineItemId: function() {
    /*start of line item id */
    if (_isAnArticle) {
      let data = sessionStorage.getItem('article');
      let pathName = location.pathname.split("/");
      let articleId = pathName[pathName.length - 1];
      if (articleId.indexOf("_") !== -1) {
        let article = articleId.split("_");
        let articleIdNumber = article[0];
        if (data == articleIdNumber) {
          sessionStorage.setItem("matched", "1");
          webmd.ads2.setPageTarget('lif', sessionStorage.getItem('lid') == null ? 0 : sessionStorage.getItem('lid'));
        }
        else {
          sessionStorage.removeItem("matched");
          sessionStorage.removeItem('lid');
          sessionStorage.removeItem("correlator");
          sessionStorage.setItem("article", articleIdNumber);
        }
      }
      else {
        sessionStorage.removeItem("matched");
        sessionStorage.removeItem('lid');
        sessionStorage.removeItem("correlator");
        sessionStorage.setItem("article", articleId);
      }
    }
    else {
      sessionStorage.removeItem("matched");
      sessionStorage.removeItem('lid');
      sessionStorage.removeItem("correlator");
      sessionStorage.removeItem('article');
    }
    /*end of line item id */

  },
  addDynamicTargetKeys: function(k, v) {
    this.dynamicTargetkeys(k, v);
  },
  postECXInvitation: function(data) {
    let _adContainer = $("#" + data.slotId);
    _adContainer.attr('style', 'background-image: none');
  },
  removeMEKeys: function(event) {
    var meArray = [ "rord", "mcs", "imid", "moa", "mop", "oaw" ]
    for (var i = 0;i < meArray.length;i++) {
      if (event.slot.getTargeting(meArray[i]).length == 1) {
        event.slot.clearTargeting(meArray[i])
      }
    }
  },
  setSSLKeys: function() {
    var obj = {
      npi: PageMetadata.userSegVars.dt != undefined ? PageMetadata.userSegVars.dt : 0,
      tar: PageMetadata.userSegVars.tar != undefined ? PageMetadata.userSegVars.tar : 0,
      tc: PageMetadata.userSegVars.tc != undefined ? PageMetadata.userSegVars.tc : 0,
      allcncpt: PageMetadata.pageSegVars.ac != undefined ? PageMetadata.pageSegVars.ac : 0,
      allspclty: PageMetadata.pageSegVars.as != undefined ? PageMetadata.pageSegVars.as : 0
    }

    Object.keys(obj).forEach((key, index) => {
      wmdSetContext("wb." + key, obj[key]);
    })
  },
  postInstreamRecricWidgetSetUp: function(data) {
    let _adContainer = $("#" + data.slotId);
    let instreamText = $("#instream-recirc");
    let topText = $("#top-recirc");

    _adContainer.addClass('active');
    instreamText.css({ 'visibility': 'visible',
      'width': '100%',
      'height': 'auto',
      'padding': '24px 0px',
      'margin': '9px 0px 24px 0px'
    });
    if (data.version == '2025') {
      instreamText.css({ 'visibility': 'visible',
      'width': '100%',
      'height': 'auto',
      'padding': '8px 0 0px 0px',
      'margin': '9px 0px 24px 0px'
    });
      topText.html('Suggested For You');
      topText.css({
          'font-size': '20px',
          'line-height': '26px',
          'color': '#161B1D',
          'text-transform': 'capitalize'
        });
        if (breakpoint === 1) {
            topText.css({
            'font-size': '16px',
            'line-height': '20.8px'
          })
        }
      }
    if (breakpoint === 1) {
      if (data.version == '2025') {
         instreamText.css({
        'margin': '1px 0px 16px 0px',
        'padding': '8px 0 16px 0px',
        'font-size': '16px'
      });
      } else {
          instreamText.css({
          'margin': '1px 0px 16px 0px',
          'padding': '16px 0px',
          'font-size': '16px'
        });
      }
      topText.css({
        'font-size': '16px'
      })
    }
    if ($("#ads-pos-916").hasClass('active') && $("#ads-pos-917").hasClass('active')) {
       if (data.version == '2025') {
          $("#ads-pos-916").css({
            'margin-bottom': '0px'
          })
        } else {
          $("#ads-pos-916").css({
            'margin-bottom': '8px'
          })
        }
    }

  },
  interscrollerInit: function(data) {
    const interscroller = document.getElementById(data.slotId);
    const interscrollerIframe = interscroller.querySelector('iframe');

    interscroller.classList.add('interscroller');
    interscrollerIframe.width = "100%";

    if (interscroller.parentNode.classList.contains('ad-item')) {
      interscroller.parentNode.classList.remove('ad-item');
      interscroller.parentNode.style.width = '100%';
    }
  },
  percentTracked: [],
  impressionViewable: function(event, slotId) {
    var iframe = document.querySelector(`div#${slotId} iframe`);
    var iframeWin = (iframe.contentWindow || iframe.contentDocument);
    var cx = {
      msg: 'ad-inview',
      slot: slotId
    };

    if (PageMetadata.reqHeaders.device == 'MOBILE') {
      // handle iframe inside friendly iframe on mobile
      if (iframeWin.document) {
        iframeWin = iframeWin.document;
      }

      var childIframe = iframeWin.querySelector('iframe');
      if (childIframe) {
        childIframe.contentWindow.postMessage(JSON.stringify(cx), '*');
      }
    } else {
      iframeWin.postMessage(JSON.stringify(cx), '*');
    }
  },
  // TODO: after new modulary footer goes to prod, remove this function (PPE-537016)
  logictoDisplayHTML5: function(event, footerFlag) {
    let styles = {
      "paddingTop": '12px',
      "paddingBottom": '10px',
      "backgroundColor": '#F2F4F5',
    };
    let fadeOutStyles = {
      "transform": 'translateY(100%)',
      "transition": 'transform 0.3s ease-out',
      "willChange": 'transform'
    };
    let element1145 = document.getElementById("ads-af-pos-1145");
    let element1145Iframe = document.querySelector('#ads-af-pos-1145 iframe');
    let wrapper1145 = document.querySelector('.adhesive-footer-wrapper');
    let hasScrolled = false;
    let scrollTimer;
    setTimeout(function() {
      if (element1145 !== null && element1145Iframe !== null && !element1145.classList.contains('blank-ad') && window.checkHTML5Creative) {
        if (wrapper1145 && !footerFlag) {
          wrapper1145.style.display = 'flex';
        }
        Object.assign(element1145.style, styles);
        element1145Iframe.style.padding = '0px';
        element1145Iframe.style.height = 'inherit';
        window.addEventListener('scroll', function handleScroll() {
          if(!hasScrolled){
            hasScrolled = true;
            if(scrollTimer){
              clearTimeout(scrollTimer);
            }
            scrollTimer = setTimeout(()=>{
              if(window.checkHTML5Creative) {
                Object.assign(wrapper1145.style, fadeOutStyles);
              }
              window.removeEventListener('scroll', handleScroll);
            },2000)
          }
        });
      }
    }, 500);
  },
  repClickHandler: function(version, device, mlink) {
    wmdPageLink("media-repc-embd-lnk_" + mlink);
  },
  addinsertInstreamRecirc: function() {
    let rootElement = $('#article-content');
    let para5th;
    let visbleSelector;
    if (rootElement.children() && rootElement.children().length > 0) {
      rootElement.find('div.csdpages').each(function(i, elem) {
        //console.log(i,elem);
        let checkClass = elem.classList.contains('csdpages');
        if (checkClass) {
          let style = window.getComputedStyle(elem, null);
          if (style.display !== 'none') {
            visbleSelector = elem;
          } else {
            //console.log("entered");
          }
        }
      });

      if (visbleSelector !== undefined) {
        //console.log(visbleSelector);
        let pElements1 = $(visbleSelector).children('p');
        para5th = pElements1[4];
      }
      else {
        let pElements2 = rootElement.children('p');
        para5th = pElements2[4];
      }
    }
    if (para5th !== undefined) {
      $('<div id="instream-recirc" style="visibility: hidden;width: 0px;height: 0px;border-top: 1px solid #D8D8D8;border-bottom: 1px solid #D8D8D8;"><div id="top-recirc" style="color:#313131;font-size:18px;padding-bottom: 12px;text-transform: uppercase;line-height: 22px;font-family: proxima_nova_rgbold;">Suggested for you</div><div id="ads-pos-916" class="AdUnit globalpromoadsunit" style="background: none;padding:0px;display:none;"></div><div id="ads-pos-917" class="AdUnit globalpromoadsunit" style="background: none;padding:0px;display:none;"></div></div>').insertAfter(para5th);
      //this.scrollEvents();
      scrollInstreamRecircEvents.init();
    }
  },
  formularyAccessApi: function(data) {
    formulary.formularyAccessApi.call(this, data);
  },
  collapseparentElement: function(data) {
    let elementId = document.getElementById(data.slotId);
    if (elementId != null) {
      if (data.type == "Broadcast") {
        elementId.classList.add('blank-ad');
        elementId.style.display = 'none';
      }
      else {
        elementId.classList.add('adlabelblank');
      }
    }
  },
};
/* New namespace with its own methods for lasy loading the bottom leaderboard */
window.lazyLoadBlb;

// lazy load on emedicine, reference and viewarticle only
window.bNews = false;
if (typeof PageMetadata !== "undefined" && typeof PageMetadata.reqHeaders !== "undefined") {
  if (PageMetadata.reqHeaders.domainCategory !== 'cme') {
    if (pageCurrentURL.indexOf('viewarticle') !== -1 || pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
      bNews = true;
    }
  }
}

window.airQcalc_noLazyLoadBlb = false;
if (window.location.pathname === '/calculator/844/airq') { // AirQ Calculator page
  if (window.ads2_ignore['141'] === 'true') {
    airQcalc_noLazyLoadBlb = true;
  }
}

let lazyLoadBlb = window.lazyLoadBlb || {};
lazyLoadBlb = {
  lazyLoadBlbSettings: {
    $window: $(window),
    lazyLoadHeight: -90,
    refresh: false,
    isiPad: false
  },

  init: function() {
    if (!bNews || airQcalc_noLazyLoadBlb) return;
    lazyLoadBlb.isiPad = /iPad/.test(navigator.platform) || (navigator.platform === 'Mac' && navigator.maxTouchPoints > 1);

    if ($('div[id^="ads-pos-141"]').length > 0) {
      var id141 = $('div[id^="ads-pos-141"]').attr("id");
      webmd.ads2.defineAd({
        id: id141,
        pos: '141',
        collapseAfter: true
      });
    }

    $(window).on('scroll', lazyLoadBlb.lazyLoadBlbscrollHandler);
  },

  refresh: function() {
    if (!bNews)
      return;
    $(window).on('scroll', lazyLoadBlb.lazyLoadBlbscrollHandler);
    lazyLoadBlb.lazyLoadBlbSettings.refresh = true;
  },

  isTriggerPointofElementInViewPort: function(el, pt) {
    // get the bounding rect for the element
    var el = el[0];
    var rect = el.getBoundingClientRect();

    // get the viewport dimensions of the document
    var width = $(window).width();
    var height = $(window).height();

    // if ipad use the screen dimensions
    if (lazyLoadBlb.isiPad) {
      // check the orientation and adjust the height
      if (window.innerHeight < window.innerWidth)
        height = screen.width; // for landscape
      else height = window.innerHeight; // for portrait
    } // end if

    // compute trigger point and test if it's in viewport
    pt = (rect.top - pt);
    return (pt >= 0 && pt <= (height));
  },

  lazyLoadBlbscrollHandler: function() {
    var blb = $('div[id^="ads-pos-141"]');
    if (blb.length && window.location.pathname !== '/calculator/844/airq') {
      // make sure the #ads-pos-141 div container is showing to get the proper offset
      // According to jQuery documentation, offset does not work if an element has a
      // display none
      blb.show();
      if (lazyLoadBlb.isTriggerPointofElementInViewPort(blb, lazyLoadBlb.lazyLoadBlbSettings.lazyLoadHeight)) {
        webmd.ads2.setPageTarget("ll", "1");
        lazyLoadBlb.disableLazyLoadBlb();
        if (lazyLoadBlb.lazyLoadBlbSettings.refresh) {
          webmd.ads2.refresh({ pos: 141 }, false);
          lazyLoadBlb.lazyLoadBlbSettings.refresh = false;
        }
        else {
          window.ads2_ignore["141"] = false;
          var id141 = $('div[id^="ads-pos-141"]').attr("id");
          webmd.ads2.defineAd({ id: id141, pos: '141' });
          var cond = $('#ads-pos-141').attr('data-google-query-id');
          var id141 = $('div[id^="ads-pos-141"]').attr("id");
          if (cond == undefined) {
            webmd.ads2.refresh({ id: id141 });
          }
        }
      }
    }
  },
  disableLazyLoadBlb: function() {
    $(window).off('scroll', lazyLoadBlb.lazyLoadBlbscrollHandler);
  }
};
if (PageMetadata.webSegVars.pc === 'hp' && pageCurrentURL.indexOf('reference') == -1 && pageCurrentURL.indexOf('emedicine') == -1) {
  window.strnativekey = {
    "ads-pos-970-sfp": "5hnBrdUyGTQJNitynu6eiSYA",
    "ads-pos-971-sfp": "wDvr9wpHFGd81PxmV2bPAEY4",
    "ads-pos-1970-sfp": "5hnBrdUyGTQJNitynu6eiSYA",
    "ads-pos-1971-sfp": "wDvr9wpHFGd81PxmV2bPAEY4"
  }
}
if (PageMetadata.webSegVars.pc === 'hp' && pageCurrentURL.indexOf('reference') !== -1) {
  window.strnativekey = {
    "ads-pos-970-sfp": "cpUmZbFeFigTjf96U64QC4Lx",
    "ads-pos-971-sfp": "KxqFYmZCw85RydDZvEDg7Jt6",
    "ads-pos-1970-sfp": "cpUmZbFeFigTjf96U64QC4Lx",
    "ads-pos-1971-sfp": "KxqFYmZCw85RydDZvEDg7Jt6"
  }
}
if (PageMetadata.webSegVars.pc === 'rc') {
  window.strnativekey = {
    "ads-pos-141-sfp": "2Bpiq7de8HqXWiL1H2CZDyFn",
    "ads-pos-520-sfp": "xLebSDx4gzHfbUGy5GFZJF6P",
    "ads-pos-420-sfp": "vC3y7j5oghqnJSnm3awPdPDZ",
    "ads-pos-1520-sfp": "xLebSDx4gzHfbUGy5GFZJF6P",
    "ads-pos-1420-sfp": "vC3y7j5oghqnJSnm3awPdPDZ",
    "ads-pos-1712-sfp": "2Bpiq7de8HqXWiL1H2CZDyFn"
  }
}
if (isDD) {
  window.strnativekey = {
    "ads-pos-421": "SVZmdJ7nKKVHCoeKxD9QUsDr",
    "ads-pos-421-sfp-b": "r9gcQxfXwKUuEQ4QpMgSJBWJ",
    "ads-pos-1421-sfp": "WUyRNBN8mNoxJvpseCvvaEQE"
  }
}
if (isEmed) {
  window.strnativekey = {
    "ads-pos-421-sfp": "c9tHXJiDr2HzQDDbu2HNDNU3",
    "ads-pos-1420": "UvM7jZDAKvLBYL8DV8WJnLyM",
    "ads-pos-1520": "Jre7nFbvL9QYQsDqupaHuQnd"
  }
}
if (pageCurrentURL.indexOf('search.') != -1) {
  window.strnativekey = {
    "ads-pos-420": "qa1GfxATsNS3n4FFpsVqYC1i",
    "ads-pos-1420": "qa1GfxATsNS3n4FFpsVqYC1i"
  }
}
if (pageCurrentURL.indexOf('viewarticle') !== -1 && locale == "us") {
  window.strnativekey = {
    "ads-pos-141-sfp": "2Bpiq7de8HqXWiL1H2CZDyFn",
    "ads-pos-142-sfp": "2Bpiq7de8HqXWiL1H2CZDyFn",
    "ads-pos-420-sfp": "E6PqWpt4dbj1tk6gFDqd4nbw",
    "ads-pos-1420-sfp": "E6PqWpt4dbj1tk6gFDqd4nbw",
    "ads-pos-1712-sfp": "2Bpiq7de8HqXWiL1H2CZDyFn",
    "ads-pos-970-sfp": "HNAZmuH98VQ5zk5tYACHWyAo",
    "ads-pos-1970-sfp": "HNAZmuH98VQ5zk5tYACHWyAo",
    "ads-pos-1420": "hjbFNvJ3mjMDh8KG2gXS6jRj",
    "ads-pos-1520": "hjbFNvJ3mjMDh8KG2gXS6jRj",
  }
}
window.profStrAd = {
  slotRendered: function(elem) {
    $(elem).closest('section').addClass("has-ad has-ad-str");
  }
};

/*
 * modified from webmd.lotame on consumer
 */

// TODO can this be removed? Investigate!
webmd.isIE9AndBelow = function() {
  return false;
};

// Add more functions onto webmd.object()
webmd.object = /** @lends webmd.object */ {

  /*! BEGIN LICENSE getObject
     * jQuery getObject
     * http://benalman.com/projects/jquery-getobject-plugin/
     * Copyright (c) 2009 "Cowboy" Ben Alman
     * Dual licensed under the MIT and GPL licenses.
     * http://benalman.com/about/license/
     * Inspired by Dojo, which is Copyright (c) 2005-2009, The Dojo Foundation.
     */

  /**
     * Get a property of an object via dot-delimited name string, and optionally
     * create the property and any ancestor properties that do not already exist.
     *
     * @param {String} name Dot-delimited string representing a property name, for
     * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
     * @param {Boolean} [create=false] Create final and intermediate properties if they don't
     * exist.
     * @param {Object} [context=window] Optional context in which to evaluate name.
     * @returns {Object} An object reference or value on success, otherwise undefined.
     *
     * @example
     * var o = webmd.object.get('webmd.m.myObject.data.part');
     * if (o) { do_something(); }
     *
     * @example
     * var o = webmd.object.get('webmd.m.myObject.data.part', true);
     * // o is guaranteed to exist because we specified the "create" option
     *
     * @example
     * // Search within the context of a known object
     * var o = webmd.object.get('myObject.data.part', webmd.m);
     *
     */
  get: function(parts, create, obj) {
    var origParts = parts;

    if (typeof parts === 'string') {
      parts = parts.split('.');
    }

    if (typeof create !== 'boolean') {
      obj = create;
      create = undefined;
    }

    obj = obj || window;
    var p;

    //first, check if the value exists as a string i.e. obj['a.b']
    if (obj[origParts] !== undefined) {
      obj = obj[origParts];
    } else {
      //otherwise, iterate through the split parts

      while (obj && parts.length) {
        p = parts.shift();
        if (obj[p] === undefined && create) {
          obj[p] = {};
        }
        obj = obj[p];
      }
    }

    return obj;
  },


  /**
     * Set a property of an object via dot-delimited name string, creating any
     * ancestor properties that do not already exist.
     *
     * @param {String} name Dot-delimited string representing a property name, for
     * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
     * @param {expression} value Any valid JavaScript expression.
     * @param {Object} [context=window] Optional context in which to evaluate name.
     *
     * @returns {expression} The value if set successfully, otherwise undefined.
     */
  set: function(name, value, context) {

    var parts = name.split('.'),
      prop = parts.pop(),
      obj = this.get(parts, true, context);

    // Only return the value if it is set successfully.
    return (obj && typeof obj === 'object' && prop) ? (obj[prop] = value) : undefined;
  },


  /**
     * Using dot-delimited name string, return whether a property of an object
     * exists.
     *
     * @param {String} name Dot-delimited string representing a property name, for
     * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
     * @param {Object} [context=window] Optional context in which to evaluate name.
     *
     * @returns {Boolean} Whether or not the property exists.
     */
  exists: function(name, context) {
    return this.get(name, context) !== undefined;
  }

  /*! END LICENCE getObject */

}; // extend webmd.object

/*
 * the module contains a lib property if the module needs to load a script first
 * encapsulate in an IFFE to simulate an imported node module at the top of the script
 * */


window.enableHeaderBidding = true;
window.$googleloaded;

